// Mock data for KLS VDIT website

export const announcements = [
  {
    id: "automark-smart-attendance-system",
    text: "📱 AutoMark: Bluetooth-Based Smart Attendance System developed by VDIT students for a smarter campus",
    description: "Tired of roll calls and proxy attendance? AutoMark is 100% proxy-proof, automatic, and secure.",
    date: "September 15, 2026",
    link: "/news-events",
    highlight: true,
    body: [
      "AutoMark - Bluetooth-Based Smart Attendance System has been developed by KLS VDIT students on the occasion of Engineers' Day.",
      "Key Features: 100% Proxy-Proof secure attendance, fully automatic (no registers or QR scanning needed).",
      "Technology Stack: Bluetooth Low Energy (BLE), Arduino / ESP32, Mobile Application, Cloud Database.",
      "View the announcement and flyer in the News & Events / Flyers gallery."
    ]
  },
  {
    id: "first-year-p-cycle-timetable-2026-27",
    text: "🕒 B.E. First Semester Time Table Published for Physics Cycle (P-Cycle, Div A–D) — AY 2026–27",
    description: "View and download 1st Semester Physics Cycle Time Tables for Divisions A, B, C, and D.",
    date: "August 31, 2026",
    link: "/programme/bsh/physics/student-resources",
    highlight: true,
    body: [
      "B.E. First Semester Timetables for Physics Cycle (P-Cycle) for the Academic Year 2026–27 have been published.",
      "Division A: Block No. 08 (Class Coordinator: Dr. Sameer Galagali)",
      "Division B: Block No. 09 (Class Coordinator: Dr. Meenal Kaliwal)",
      "Division C: Block No. 5B (Class Coordinator: Dr. M. K. Patil)",
      "Division D: Block No. 04 (Class Coordinator: Dr. M. S. Sannaikar)",
      "Click the link above to view and download the official PDF timetables on the Physics Student Resources page."
    ]
  },
  {
    id: "first-year-c-cycle-timetable-2026-27",
    text: "🕒 B.E. First Semester Time Table Published for Chemistry Cycle (C-Cycle, Div E–I) — AY 2026–27",
    description: "View and download 1st Semester Chemistry Cycle Time Tables for Divisions E, F, G, H, and I.",
    date: "August 31, 2026",
    link: "/programme/bsh/chemistry/student-resources",
    highlight: true,
    body: [
      "B.E. First Semester Timetables for Chemistry Cycle (C-Cycle) for the Academic Year 2026–27 have been published.",
      "Division E: Block No. 18 (Class Coordinator: Prof. Nikhil K)",
      "Division F: Block No. 14, 18, 19 (Class Coordinator: Prof. Vijaya Chitrali)",
      "Division G: Block No. 16 (Class Coordinator: Dr. G. S. Kurdekar)",
      "Division H: Block No. 2nd Floor, Mech Research Center (Class Coordinator: Faculty)",
      "Division I: Block No. 19 (Class Coordinator: Dr. Satish Hande)",
      "Click the link above to view and download the official PDF timetables on the Chemistry Student Resources page."
    ]
  },

  {
    id: "whatsapp-channel-2026",
    text: "📱 KLS VDIT First Year 2026–27 WhatsApp Channel Launched",
    description: "Important updates, notices, announcements and information for First Year students.",
    date: "August 13, 2026",
    externalLink: "https://whatsapp.com/channel/0029VbDLwo405MUViuC9se1m",
    linkText: "Follow WhatsApp Channel",
    highlight: true,
    body: [
      "All First Year students admitted for the academic year 2026–27 are requested to join the official KLS VDIT First Year 2026–27 WhatsApp Channel.",
      "The channel will be used to share important academic updates, notices, announcements, orientation and induction programme information, timetables, events, and other important information related to First Year students.",
      "Students and parents are advised to follow the channel regularly to stay updated with official information from KLS VDIT, Haliyal.",
      "Click the “Follow WhatsApp Channel” button above to join the channel.",
      "Please note: The WhatsApp Channel is intended for official announcements and updates. Students should regularly check the channel for important information."
    ]
  },
  { id: "recruitment-2026-08", text: "Announcement: Applications are invited from eligible candidates for the post of Assistant Professor in the Civil Engineering and Mathematics departments", date: "August 13, 2026", link: "/recrutement", highlight: true },
  { id: "adm-2026", text: "Admissions Open for Academic Year 2026-27 | 9448420102 | 7760372312", date: "April 15, 2026" },
  { id: "aiml-launch", text: "B.E. in CSE(Data Science) — New Programme launched. Limited seats.", date: "April 10, 2026" },
  // { id: "iedc-fy26", text: "VDIT IEDC invites student startup proposals for FY26 funding round.", date: "March 20, 2026" },
];

export const heroSlides = [
  { id: 1, image: "/HomePage/college.jpeg", title: "ADMISSIONS OPEN | 2026-27", subtitle: "Engineering Excellence at KLS VDIT", cta: "Apply Now", link: "/admissions" },
  { id: 2, image: "/HomePage/2.png", title: "22 YEARS OF TECHNICAL EXCELLENCE", subtitle: "Transforming Through Technology since 2004", cta: "EXPLORE OUR LEGACY", link: "/about/our-history" },
  { id: 3, image: "/HomePage/3.png", title: "INDUSTRY-INTEGRATED CENTER OF EXCELLENCE", subtitle: "Transforming Ideas into Industry-Ready Solutions", cta: "VISIT THE CAMPUS", link: "/campus" },
  { id: 4, image: "/HomePage/4.png", title: "NEW B.E. IN CSE(Data Science)", subtitle: "Future-ready programmes for the modern engineer", cta: "LEARN MORE", link: "/programme/cse-aids" },
];

export const departments = [
  {
    id: "cse",
    name: "Computer Science & Engineering",
    short: "CSE",
    programmeType: "ug",
    programmeLabel: "B.E.",
    duration: "4 Years (8 Semesters)",
    intake: 120,
    established: 2004,
    description: "Established in 2004, the department offers a B.E. programme with specialisations in software engineering, data structures, computer networks and emerging areas of computing.",
    image: "/Infrastructure/CSE/3.jpg",
    hodId: "f-venkatesh-shankar",
    labs: ["Programming Lab", "Database Lab", "Networks Lab", "Cyber Security Lab", "Data Science Lab"],
    research: "Software Engineering \u00b7 Cloud Computing \u00b7 Cybersecurity \u00b7 Data Mining",
    researchFundedProjects: 3,
    accreditation: ["NBA Accredited (Tier-2) since 2018", "VTU Recognised Research Centre", "AICTE Approved Intake: 120 seats"],
    achievements: [
      "ACM Inter-Collegiate Programming Champions, Karnataka, 2025",
      "Smart India Hackathon 2024 \u2014 Hardware Track Winners",
      "Best Paper Award at ICACCS 2025 (Bengaluru)",
      "VTU Gold Medal \u2014 Ms. Pooja Kulkarni, Batch 2024",
    ],
    projects: [
      { title: "IoT Smart Agriculture for Uttara Kannada", funding: "VGST Karnataka", amount: "\u20b9 12 L" },
      { title: "Federated Learning for Rural Healthcare", funding: "AICTE RPS", amount: "\u20b9 8 L" },
      { title: "Cyber Threat Intelligence Platform", funding: "DST Nidhi", amount: "\u20b9 15 L" },
    ],
  },
  {
    id: "cse-aiml",
    name: "Computer Science & Engineering (AI & ML)",
    short: "CSE (AI & ML)",
    programmeType: "ug",
    programmeLabel: "B.E.",
    duration: "4 Years (8 Semesters)",
    intake: 60,
    established: 2022,
    description: "A future-ready programme focussing on artificial intelligence, machine learning, deep learning, and intelligent systems for industry 4.0.",
    image: "https://images.pexels.com/photos/9243572/pexels-photo-9243572.jpeg?w=1000",
    hodId: "f-poornima-raikar",
    labs: ["AI Lab", "Deep Learning Studio", "GPU Compute Lab", "Robotics Lab"],
    research: "Computer Vision \u00b7 NLP \u00b7 Reinforcement Learning \u00b7 Edge AI",
    researchFundedProjects: 2,
    accreditation: ["AICTE Approved Intake: 60 seats", "VTU Affiliated since 2022", "NAAC accreditation under preparation for first NBA cycle"],
    achievements: [
      "Top 10 Finalist \u2014 Microsoft Imagine Cup India, 2025",
      "Best AI Project Award at TANTRAJNANA 2025",
      "Selected for NVIDIA AI Educator Programme, 2025",
    ],
    projects: [
      { title: "Multilingual NLP for Kannada-English Code-Mixing", funding: "AICTE RPS", amount: "\u20b9 10 L" },
      { title: "Edge-AI for Wildlife Monitoring \u2014 Dandeli Forest Range", funding: "Karnataka Forest Dept.", amount: "\u20b9 6 L" },
    ],
  },
  {
    id: "cse-aids",
    name: "Computer Science & Engineering(Data Science)",
    short: "CSE(Data Science)",
    programmeType: "ug",
    programmeLabel: "B.E.",
    duration: "4 Years (8 Semesters)",
    intake: 60,
    established: 2026,
    description: "A future-ready programme focusing on artificial intelligence, data science, analytics, machine learning, and intelligent data-driven systems.",
    image: "https://images.pexels.com/photos/8386440/pexels-photo-8386440.jpeg?w=1000",
    labs: ["Programming Lab", "Data Science Lab", "AI Lab", "Machine Learning Lab"],
    research: "Artificial Intelligence · Data Science · Machine Learning · Big Data Analytics",
    researchFundedProjects: 1,
    accreditation: ["AICTE Approved Intake: 60 seats", "VTU Affiliated", "Programme details to be updated"],
    achievements: ["Programme achievements will be updated."],
    projects: [
      { title: "AI and Data Science Student Projects", funding: "Department activity", amount: "To be updated" },
    ],
  },
  {
    id: "ece",
    name: "Electronics & Communication Engineering",
    short: "E&CE",
    programmeType: "ug",
    programmeLabel: "B.E.",
    duration: "4 Years (8 Semesters)",
    intake: 60,
    established: 2004,
    description: "The E&CE department prepares students in VLSI design, embedded systems, signal processing, and wireless communication with state-of-the-art labs.",
    image: "/HomePage/dept/ece.jpeg",
    hodId: "f-plasin-francis-dias",
    labs: ["VLSI Lab", "Embedded Systems Lab", "Communication Lab", "DSP Lab"],
    research: "VLSI Design \u00b7 Wireless Networks \u00b7 IoT \u00b7 Image Processing",
    researchFundedProjects: 2,
    accreditation: ["NBA Accredited (Tier-2) since 2019", "VTU Recognised Research Centre", "AICTE Approved Intake: 60 seats"],
    achievements: [
      "IEEE Best Student Branch Award (Karnataka Section), 2024",
      "Patent filed: Low-power VLSI architecture for IoT edge nodes",
      "Three students published in IEEE Sensors Journal, 2025",
    ],
    projects: [
      { title: "5G Beamforming Test-bed", funding: "DST SERB", amount: "\u20b9 18 L" },
      { title: "Wearable Health Monitor \u2014 Rural Karnataka", funding: "VGST", amount: "\u20b9 9 L" },
    ],
  },
  {
    id: "eee",
    name: "Electrical & Electronics Engineering",
    short: "EEE",
    programmeType: "ug",
    programmeLabel: "B.E.",
    duration: "4 Years (8 Semesters)",
    intake: 60,
    established: 2004,
    description: "Focuses on power systems, control engineering, renewable energy, and electrical machines, training engineers for India's evolving energy sector.",
    image: "/HomePage/dept/eee.jpeg",
    hodId: "f-rajeshwari-nanannavar",
    labs: ["Power Systems Lab", "Electrical Machines Lab", "Control Systems Lab",],
    research: "Smart Grids \u00b7 Power Electronics \u00b7 Renewable Energy \u00b7 EV Systems",
    researchFundedProjects: 2,
    accreditation: ["NBA Accredited (Tier-2) since 2020", "AICTE Approved Intake: 60 seats", "MoU with KREDL for joint research"],
    achievements: [
      "MNRE Sponsored Solar Energy Centre established, 2024",
      "First Prize \u2014 IEEE Power Engineering Quiz, Karnataka, 2025",
      "Faculty publication in IEEE Transactions on Sustainable Energy",
    ],
    projects: [
      { title: "Hybrid Solar-Wind Microgrid for Western Ghats", funding: "MNRE", amount: "\u20b9 22 L" },
      { title: "EV Charging Infrastructure Study", funding: "KREDL", amount: "\u20b9 7 L" },
    ],
  },
  {
    id: "me",
    name: "Mechanical Engineering",
    short: "ME",
    programmeType: "ug",
    programmeLabel: "B.E.",
    duration: "4 Years (8 Semesters)",
    intake: 60,
    established: 2004,
    description: "Offers a comprehensive curriculum in thermodynamics, manufacturing, design and mechatronics, supported by modern workshops and CAD/CAM facilities.",
    image: "/HomePage/dept/mech.jpeg",
    hodId: "f-k-s-pujari",
    labs: ["CAD/CAM Lab", "Thermodynamics Lab", "Fluid Mechanics Lab", "Manufacturing Workshop"],
    research: "Additive Manufacturing \u00b7 Tribology \u00b7 Thermal Engineering \u00b7 Mechatronics",
    researchFundedProjects: 2,
    accreditation: ["NBA Accredited (Tier-2) since 2019", "AICTE Approved Intake: 60 seats", "Industry MoU with Bosch & Mahindra"],
    achievements: [
      "SAE BAJA 2025 \u2014 All India Rank 38",
      "Go-Kart Championship Karnataka \u2014 Runners-up, 2024",
      "Two patents granted in additive manufacturing, 2025",
    ],
    projects: [
      { title: "FDM 3D Printing of Bio-composites", funding: "DST SERB", amount: "\u20b9 14 L" },
      { title: "Tribological Study of Hybrid Bearings", funding: "AICTE RPS", amount: "\u20b9 8 L" },
    ],
  },
  {
    id: "civil",
    name: "Civil Engineering",
    short: "Civil",
    programmeType: "ug",
    programmeLabel: "B.E.",
    duration: "4 Years (8 Semesters)",
    intake: 60,
    established: 2004,
    description: "Trains engineers in structural analysis, environmental engineering, geotechnics, and construction management for sustainable infrastructure.",
    image: "https://images.pexels.com/photos/12091126/pexels-photo-12091126.jpeg?w=1000",
    hodId: "f-harsha-a-jadhav",
    labs: ["Structural Lab", "Geotechnical Lab", "Surveying Lab", "Environmental Lab"],
    research: "Sustainable Materials \u00b7 Water Resources \u00b7 Earthquake Engineering",
    researchFundedProjects: 2,
    accreditation: ["AICTE Approved Intake: 60 seats", "NBA accreditation visit \u2014 March 2026", "MoU with PWD Karnataka"],
    achievements: [
      "Best Student Project \u2014 ICI Karnataka Chapter, 2025",
      "National Conference on Sustainable Engineering hosted, 2026",
      "Funded study on flood resilience for Ghataprabha basin",
    ],
    projects: [
      { title: "Sustainable Concrete with Industrial Byproducts", funding: "DST SERB", amount: "\u20b9 12 L" },
      { title: "Earthquake Vulnerability Mapping \u2014 N. Karnataka", funding: "Karnataka SDMA", amount: "\u20b9 9 L" },
    ],
  },
  {
    id: "bsh",
    name: "Basic Science & Humanities",
    short: "BSH",
    programmeType: "ug",
    programmeLabel: "Basic Science",
    duration: "First-year engineering foundation",
    intake: null,
    established: 2004,
    description: "Supports first-year engineering education through mathematics, physics, chemistry, communication skills, and humanities foundations.",
    image: "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=1000&q=80",
    hodId: "f-vinod-naik",
    labs: ["Physics Lab", "Chemistry Lab", "Language Lab", "Mathematics Learning Centre"],
    research: "Mathematics · Physics · Chemistry · Humanities",
    accreditation: ["Supports all AICTE-approved undergraduate engineering programmes", "VTU-affiliated first-year curriculum"],
    achievements: [
      "Faculty research contributions across mathematics, physics, and chemistry",
      "Foundation courses delivered for all engineering branches",
    ],
    projects: [],
  },

];

// Faculty list with structured profiles. Each faculty has a stable id used in routes /faculty/:id
export const faculty = [
  {
    "id": "f-sneha-s-kulkarni",
    "name": "Dr. Sneha S. Kulkarni",
    "role": "Assistant Professor",
    "deptId": "bsh",
    "image": "/FacultyCImages/DR_sneha_kulkarni_BSH.jpeg",
    "qualifications": "M.Tech., Ph.D.",
    "experience": "15 years",
    "email": "ssk@klsvdit.edu.in",
    "phone": "+91 99861 33660",
    "linkedin": "",
    "areas": [
      "Novel heterocycle synthesis",
      "biofuels",
      "organic chemistry",
      "nano materials"
    ],
    "courses": [
      "Engineering Chemistry For Computer Science And Engineering (CSE) Branch",
      "Electrical And Electronics Engineering (EEE)",
      "Mechanical Engineering (ME) And Civil Branch",
      "Environmental Studies"
    ],
    "publications": 10,
    "projects": 0,
    "bio": "Dr. Sneha S. Kulkarni completed her B.Sc. (2009) and M.Sc. in Organic Chemistry (2011) from Karnataka University, Dharwad, and earned her Ph.D. from VTU, Belagavi, in 2023. She has 15 years of teaching experience and has published 10 research papers in reputed national and international journals.",
    "irins": "",
    "recognition": [
      "She received the Best Research Paper Award at the Global Nexus International Conference in recognition of her research contributions",
      "Cultural committee member",
      "News letter committee member",
      "Eco Club member"
    ]
  },
  {
    "id": "f-mallikarjun-k-patil",
    "name": "Dr. Mallikarjun K. Patil",
    "role": "Assistant Professor",
    "deptId": "bsh",
    "image": "/FacultyCImages/DR_mallikarjun_patil_BSH.jpeg",
    "qualifications": "M.Tech., Ph.D.",
    "experience": "10 years",
    "email": "mkp@klsvdit.edu.in",
    "phone": "+91 80953 22215",
    "linkedin": "https://www.linkedin.com/in/mallikarjun-k-patil-6717571a0/",
    "areas": [
      "Time resolved spectroscopy",
      "Fluorescence Resonance Energy Transfer (FRET) / Surface Energy Transfer (SET) using nanoparticles-dye systems",
      "Nanomaterial based sensors",
      "Solute-solvent interaction using fluorescent dyes"
    ],
    "courses": [
      "Quantum Physics And Applications",
      "Electrical Engineering Materials",
      "Research Methodology & Intellectual Property Rights",
      "Soft Skills"
    ],
    "publications": 45,
    "projects": 0,
    "bio": "Dr. Mallikarjun K. Patil is an Assistant Professor of Physics at KLS VDIT, Haliyal, and earned his Ph.D. from Karnatak University, Dharwad. He has published over 45 research papers, with 500+ citations, an h-index of 12, and an i10-index of 14. A recipient of the Indian Science Congress Young Scientist Award (2020), he has over seven years of teaching and ten years of research experience.",
    "irins": "",
    "recognition": [
      "Indian Science Congress Young Scientist Award (2020) Awarded by the Indian Science Congress Association, a premier scientific body under the Department of Science and Technology (DST), Government of India",
      "Department of Science and Technology (DST) Doctor of Philosophy (Ph.D.) Fellowship Award (2020-2021) Received the Department of Science and Technology (DST), Government of Karnataka Doctor of Philosophy (Ph.D.) Fellowship, recognizing research excellence and supporting advanced doctoral research in the field of fluorescence spectroscopy and nanomaterials",
      "Society of Photo-Optical Instrumentation Engineers (SPIE) Officers' Travel Grant Award (2020) Selected by Society of Photo-Optical Instrumentation Engineers (SPIE) - The International Society for Optics and Photonics to participate in Photonics West 2020, held in San Diego, California, USA",
      "Qualification in Karnataka State Eligibility Test (K-SET) for Assistant Professorship (2018)",
      "Best Publication Awards from Karnatak University, Dharwad (2018 and",
      "as a collaborative author",
      "Founding President of the Society of Photo-Optical Instrumentation Engineers (SPIE) Karnatak University Student Chapter (2019-2021)",
      "Life Membership in the Indian Science Congress Association",
      "Member of International Society for Optics and Photonics (Society of Photo-Optical Instrumentation Engineers (SPIE))",
      "Early career member of Optica (OPTICA), formerly Optical Society of America (OSA)",
      "Best Paper Presentation Award at the 1st Asia Pacific Conference on Engineering, Education, Social Science and Humanities (APCEESH), Thailand,",
      "8. Best Paper Presentation Award at the National Conference on \"The 100 Years of Quantum Physics: Developments and Multidisciplinary Applications in Novel Materials (NCQP-2026)\" Karnatak University, Dharwad 2026"
    ]
  },
  {
    "id": "f-sameer-m-galagali",
    "name": "Dr. Sameer. M. Galagali",
    "role": "Associate Professor",
    "deptId": "bsh",
    "image": "/FacultyCImages/DR_sameer_galagali_BSH.jpeg",
    "qualifications": "M.Tech., Ph.D.",
    "experience": "25 years",
    "email": "smg@klsvdit.edu.in",
    "phone": "+91 99161 86186",
    "linkedin": "https://www.linkedin.com/in/dr-sameer-galagali-06981572/",
    "areas": [
      "Semiconductor Nano-structures and Nano-materials",
      "Quantum Transport and Charge Carrier Dynamics",
      "Nano-scale Electronic Devices and Device Physics",
      "Theoretical and Computational Condensed Matter Physics"
    ],
    "courses": [
      "Quantum Physics And Applications",
      "Physics For Sustainable Structures",
      "Physics Of Materials",
      "Quantum Physics And Electronic Sensors"
    ],
    "publications": 6,
    "projects": 1,
    "bio": "Dr. Sameer M. Galagali serves as Associate Professor of Physics at KLS Vishwanathrao Deshpande Institute of Technology, Haliyal. His work explores the fundamental physics of semiconductor nano-structures, electron transport, and quantum phenomena underlying modern electronic technologies. He is committed to fostering scientific inquiry, academic excellence, and innovation through research and scholarly engagement.",
    "irins": "https://klsvdit.irins.org/profile/249257",
    "recognition": [
      "Coordinator and Host of All India Council for Technical Education (AICTE)-sponsored All India Council for Technical Education (AICTE) Training and Learning (ATAL) Faculty Development Programmes",
      "Resource Person for invited lectures on emerging areas of Physics and Semiconductor Technology",
      "Researcher in Semiconductor Nano-structures and Quantum Transport"
    ]
  },
  {
    "id": "f-meenal-m-kaliwal",
    "name": "Dr. Meenal M. Kaliwal",
    "role": "Assistant Professor",
    "deptId": "bsh",
    "image": "/FacultyCImages/DR_meenal_kaliwal_BSH.jpeg",
    "qualifications": "M.Tech., Ph.D.",
    "experience": "19 years",
    "email": "mmk@klsvdit.edu.in",
    "phone": "+91 95910 45062",
    "linkedin": "https://www.linkedin.com/in/dr-meenal-kaliwal-06978627",
    "areas": [
      "Graph Theory",
      "Discrete Mathematics"
    ],
    "courses": [
      "Differential Calculus & Linear Algebra",
      "Calculus",
      "Laplace Transform & Numerical Techniques",
      "Applied Mathematics"
    ],
    "publications": 10,
    "projects": 0,
    "bio": "Dr. Meenal M. Kaliwal is an Assistant Professor with 19 years of teaching experience. Her research focuses on Graph Theory and its generalizations and she currently guides a Ph.D. scholar. She is skilled in Research, MATLAB and Python and also serves as Chairperson of the Internal Complaints Committee and Women's Cell.",
    "irins": "https://klsvdit.irins.org/profile/248887",
    "recognition": [
      "As Head of the Mathematics Research Centre at Karnatak Law Society (KLS) Vishwanathrao Deshpande Institute of Technology (VDIT), Dr. Meenal M. Kaliwal plays a key role in fostering research, innovation and academic excellence in Mathematics",
      "Published Patent titled \"Internet of Things (IoT) ENABLED WRONG POSTURE MONITORING AND ALERT SYSTEM\"",
      "Published more than 15 research articles in reputed journals and conference proceedings",
      "Attended and contributed to over 25 International and National conferences, workshops and symposia, fostering academic collaboration and knowledge exchange"
    ]
  },
  {
    "id": "f-g-s-kurdekar",
    "name": "Dr. G. S. Kurdekar",
    "role": "Assistant Professor",
    "deptId": "bsh",
    "image": "/FacultyCImages/DR_gurunath_kurudekar_BSH.jpeg",
    "qualifications": "M.Tech., Ph.D.",
    "experience": "12 years",
    "email": "gsk@klsvdit.edu.in",
    "phone": "+91 96114 56880",
    "linkedin": "https://in.linkedin.com/in/g-s-kurdekar-4754541b7",
    "areas": [
      "Coordination chemistry and catalysis"
    ],
    "courses": [
      "Applied Chemistry For Electronics And Communication (EC) Stream",
      "Applied Chemistry For Sustainable Structures And Material Design For Civil Stream",
      "Applied Chemistry For Advanced Metal Protection And Sustainable Energy System For Mechanical Stream",
      "Research Methodology"
    ],
    "publications": 11,
    "projects": 0,
    "bio": "Dr. G. S. Kurdekar heads the Department of Chemistry at KLS VDIT. His research interests include coordination compounds and their applications, as well as catalysis studies.He has 12 years of teaching experience Published 12 research article",
    "irins": "",
    "recognition": [
      "information to be updated"
    ]
  },
  {
    "id": "f-vinod-naik",
    "name": "Dr. Vinod Naik",
    "role": "HOD and Associate Professor",
    "deptId": "bsh",
    "image": "/FacultyCImages/DR_vinod_naik_BSH.jpeg",
    "qualifications": "M.Tech., Ph.D.",
    "experience": "14 years",
    "email": "hodbsh@klsvdit.edu.in, vhn@klsvdit.edu.in",
    "phone": "+91 99803 21240",
    "linkedin": "https://www.linkedin.com/in/dr-vinod-naik-4975aa2b0/",
    "areas": [
      "Coordination Chemistry",
      "Molecular Docking Studies",
      "Synthetic Organic Chemistry"
    ],
    "courses": [
      "Engineering Chemistry For Computer Science (CS) Stream",
      "Engineering Chemistry For Computer Science (CS) Electrical Stream",
      "Research Samaskratika Kannada"
    ],
    "publications": 14,
    "projects": 0,
    "bio": "Dr. Vinod Naik is an Associate Professor in the Department of Chemistry with a Ph.D. in Inorganic Chemistry. His research focuses on inorganic and coordination chemistry. He has published 14 research papers in reputed international journals and successfully guided two scholars to earn their Ph.D. degrees under his supervision.",
    "irins": "https://klsvdit.irins.org/profile/268848",
    "recognition": [
      "Published 14 Research papers in Reputed Journals and Under my Guidance awarded 02 Phd"
    ]
  },
  {
    "id": "f-vijaya-chitrali",
    "name": "Mrs. Vijaya Chitrali",
    "role": "Assistant Professor",
    "deptId": "bsh",
    "image": "/FacultyCImages/vijaya_chaitrali_BSH.jpeg",
    "qualifications": "M.Tech.",
    "experience": "18 years",
    "email": "vtc@klsvdit.edu.in",
    "phone": "+91 99724 08247",
    "linkedin": "https://www.linkedin.com/in/vijaya-chitrali-b145b4277/",
    "areas": [
      "Graph theory"
    ],
    "courses": [
      "Discrete Mathematical Structures",
      "Calculus & Linear Algebra",
      "Numerical Methods",
      "Mathematics For Computer Science"
    ],
    "publications": 0,
    "projects": 0,
    "bio": "Mrs. Vijaya Chitrali is an Assistant Professor in the Department of Mathematics at KLS VDIT. She is passionate about teaching and helping students build strong conceptual understanding. Committed to academic excellence, she encourages learners to enhance their knowledge, skills, and confidence, preparing them for successful academic and professional careers.",
    "irins": "https://klsvdit.irins.org/profile/149813",
    "recognition": [
      "Faculty Development Programme (FDP) - 5"
    ]
  },
  {
    "id": "f-akshata-b-patil",
    "name": "Prof. Akshata B Patil",
    "role": "Assistant professor",
    "deptId": "bsh",
    "image": "/FacultyCImages/Akshata_patil_BSH.jpeg",
    "qualifications": "M.Tech.",
    "experience": "10 years",
    "email": "abp@klsvdit.edu.in",
    "phone": "+91 87226 28237",
    "linkedin": "https://www.linkedin.com/in/akshata-patil-aa90b420a",
    "areas": [
      "Graph Theory and Numerical methods"
    ],
    "courses": [
      "Engineering Mathematics 1,2,3 And 4"
    ],
    "publications": 0,
    "projects": 0,
    "bio": "Mrs. Akshata B. Patil is an Assistant Professor in the Department of Mathematics at KLS VDIT with 10 years of teaching experience. She specializes in Graph Theory and Numerical Methods and is committed to innovative teaching practices. Her ability to simplify complex concepts fosters student engagement, academic excellence, and a positive learning environment.",
    "irins": "",
    "recognition": [
      "information to be updated"
    ]
  },
  {
    "id": "f-satish-hande",
    "name": "Dr. Satish Hande",
    "role": "Associate Professor",
    "deptId": "bsh",
    "image": "/FacultyCImages/DR_satish_hande_BSH.jpeg",
    "qualifications": "M.Tech., Ph.D.",
    "experience": "23 years",
    "email": "sph@klsvdit.edu.in",
    "phone": "+91 80504 25503",
    "linkedin": "https://www.linkedin.com/in/satish-hande",
    "areas": [
      "Graph theory",
      "Discrete mathematics",
      "Linear Programming"
    ],
    "courses": [
      "Engineering Mathematics-I, II, III, IV",
      "Linear Algebra",
      "Discrete Mathematics",
      "Graph Theory"
    ],
    "publications": 22,
    "projects": 0,
    "bio": "Dr. Satish Hande is an Associate Professor in the Department of Mathematics at KLS VDIT. With 23 years of teaching experience at undergraduate and postgraduate levels, he is passionate about mathematics education and research. His areas of interest include Graph Theory, Discrete Mathematics, and Linear Programming. He currently guides three Ph.D. scholars.",
    "irins": "https://klsvdit.irins.org/profile/265750-937337",
    "recognition": [
      "Life member of A member of Indian Society for Technical Education (ISTE)"
    ]
  },
  {
    "id": "f-m-s-sannaikar",
    "name": "Dr. M. S. Sannaikar",
    "role": "Assistant Professor",
    "deptId": "bsh",
    "image": "/FacultyCImages/DR_m_s_sannaikar_BSH.jpeg",
    "qualifications": "M.Tech., Ph.D.",
    "experience": "7 years",
    "email": "mss@klsvdit.edu.in",
    "phone": "+91 81528 62489",
    "linkedin": "https://in.linkedin.com/in/m-s-sannaikar-719b9b70",
    "areas": [
      "Fluorescence Spectroscopy",
      "Bio-Sensors",
      "Nanostructures and Density Functional Theory"
    ],
    "courses": [
      "Engineering Physics For Computer Science And Engineering (CSE)",
      "Engineering Physics For Computer Science And Engineering - Artificial Intelligence And Machine Learning (CSE-AIML)",
      "Engineering Physics For Electrical And Electronics Engineering (EEE)"
    ],
    "publications": 25,
    "projects": 0,
    "bio": "Dr. M. S. Sannaikar completed a Ph.D. on fluorescence spectroscopic studies of nanostructures and dyes (2019). M.Sc. in 2012. Recipient of the Young Scientist Travel Grant (France, 2018), K-SET qualified (2014), with over 25 research publications in the field of spectroscopy and nanoscience.",
    "irins": "https://klsvdit.irins.org/profile/271422",
    "recognition": [
      "Recipient of the Young Scientist Travel Grant (France,",
      "Member of Society of Photo-Optical Instrumentation Engineers (SPIE) Photonics",
      "Annual Member of Indian Science Congress Association (ISCA)",
      "Actively participated in Unnat Bharat Abhiyan (UBA) outreach activity"
    ]
  },
  {
    "id": "f-harsha-a-jadhav",
    "name": "Harsha A. Jadhav",
    "role": "Assistant Professor and HOD",
    "deptId": "civil",
    "image": "/FacultyCImages/harsha_jadhav_CIVIL.jpeg",
    "qualifications": "M.Tech.",
    "experience": "14.5 years",
    "email": "hodcivil@klsvdit.edu.in, haj@klsvdit.edu.in",
    "phone": "+91 98866 67910",
    "linkedin": "https://www.linkedin.com/in/harsha-jadhav-721909413",
    "areas": [
      "Pavement Design",
      "Traffic planning",
      "Town planning",
      "Software based traffic analysis"
    ],
    "courses": [
      "Highway Engineering",
      "Airport Engineering",
      "Pavement Materials",
      "Railway Engineering"
    ],
    "publications": 0,
    "projects": 0,
    "bio": "Prof. Harsha Jadhav completed B.E Civil from BEC Bagalkot and M.Tech from NITK Surathkal. From past 14 years working at KLS VDIT.",
    "irins": "https://vidwan.inflibnet.ac.in/profile/248691",
    "recognition": [
      "information to be updated"
    ]
  },
  {
    "id": "f-rakesh-patil",
    "name": "Prof. Rakesh Patil",
    "role": "Assistant Professor",
    "deptId": "civil",
    "image": "/FacultyCImages/rakesh_patil_CIVIL.jpeg",
    "qualifications": "M.Tech.",
    "experience": "11 years",
    "email": "rjp@klsvdit.edu.in",
    "phone": "+91 81478 61076",
    "linkedin": "https://www.linkedin.com/in/rakesh-patil-63aa86129",
    "areas": [
      "Geology",
      "Remote Sensing and Geographic Information Systems (GIS)",
      "Hydrology",
      "Advanced Surveying"
    ],
    "courses": [
      "Engineering Geology",
      "Remote Sensing And Geographic Information Systems (GIS)",
      "Watershed Management",
      "Environment Engineering"
    ],
    "publications": 4,
    "projects": 4,
    "bio": "Mr. Rakesh Patil heads the Engineering Geology Laboratory and specializes in Engineering Geology, GIS, and QGIS applications. He is actively involved in geological mapping, watershed management, remote sensing, geospatial analysis, and environmental studies. He guides students in practical training, research activities, and consultancy projects related to sustainable development.",
    "irins": "",
    "recognition": [
      "Member of Professional bodies Institution of Engineers India (IEI)",
      "A member of Indian Society for Technical Education (ISTE)"
    ]
  },
  {
    "id": "f-ashik-bellary",
    "name": "Dr. Ashik Bellary",
    "role": "Associate Professor",
    "deptId": "civil",
    "image": "/FacultyCImages/DR_ashik_ballary_CIVIL.jpeg",
    "qualifications": "M.Tech., Ph.D.",
    "experience": "10 years",
    "email": "acb@klsvdit.edu.in",
    "phone": "+91 97382 55856",
    "linkedin": "https://linkedin.com/in/ashik-bellary-73191160",
    "areas": [
      "Pavement Materials",
      "Pavement Analysis and Design",
      "Traffic Engineering",
      "Application of Artificial Intelligence (AI) and Machine Learning (ML) in Civil Engineering"
    ],
    "courses": [
      "Design And Construction Of Highway Pavements",
      "Geotechnical Engineering",
      "Concrete Technology",
      "Road Safety Engineering"
    ],
    "publications": 7,
    "projects": 0,
    "bio": "Dr. Ashik C. Bellary is Associate Professor in Civil Engineering at KLS VDIT, Haliyal. He is a Justo Gold Medalist in M.E. Highway Engineering, holds a PhD from NITK Surathkal, specializes in concrete pavement design, sustainable materials, and mining waste utilization, with 10 years of experience, and has published SCI and Scopus journal articles.",
    "irins": "https://klsvdit.irins.org/profile/259179",
    "recognition": [
      "\"Ph.D Research Fellowship\", National Institute of Technology Karnataka, Surathkal, India, 2017",
      "Prof. C E G Justo Gold Medal\", in 53rd Bangalore University convocation for scoring highest marks in Master of Engineering (M.E).- Highway Engineering",
      "\"Post Graduate Scholarship (GATE)\", Ministry of Human Resource and Development, Government of India, 2014-2016",
      "\"Best Project of the Year - 2017 award\", (For Guiding the Project) in Karnataka State Council for Science and Technology (KSCST)'s Student Project Programme (SPP) exhibition held at Nitte Mahalinga Adyanthaya Memorial (NMAM) Institute of Technology, Nitte",
      "\"Chairperson\", International Conference on Sustainable Infrastructure: Innovations, Opportunities and Challenges-2023 (SIIOC-2023) organised by National Institute of Technology Karnataka (NITK) Surathkal",
      "Reviewer for International Journal of Pavement Engineering, Discover Materials and Sustainable Innovation Infrastructure Springer Publishers",
      "Successfully completed \"Indo Universal Collaboration for Engineering Education (IUCEE) International Engineering Educator Certification Program\" Spring",
      "Successfully completed All India Council for Technical Education (AICTE) Quality Improvement Programme (QIP) Postgraduate (PG) Certification Program on \"Machine Learning\" a six-months course at IISc (Indian Institute of Science) Bengaluru from July 2024 - December",
      "Invited as \"Guest of Honour\" for Engineers Day Celebration 2024 at Karwar organised by Association of Consulting Civil Engineers Karwar",
      "\"Member of Advisory committee\" Civil Technology (CIVITECH) Summit 2025, organised by Association of Consulting Civil Engineers, Dharwad Local Centre on 1st and 2nd March 2025",
      "Received \"Vocational Excellence Award\" on 5th September 2025 from Association of Consulting Civil Engineers (ACCE) Dharwad Local Centre (DLC)",
      "Life time member of Indian Roads Congress (IRC)",
      "Life time member of Indian Geotechnical Society (IGS)",
      "A member of Indian Society for Technical Education (ISTE)",
      "Institution of Engineers India (IEI)",
      "Life time member of Indian Concrete Institute (ICI)",
      "Certified Chartered Civil Engineer"
    ]
  },
  {
    "id": "f-siddalingayya-g-hiremath",
    "name": "Prof. Siddalingayya G Hiremath",
    "role": "Assistant Professor",
    "deptId": "civil",
    "image": "/FacultyCImages/s_g_hiremath_CIVIL.jpeg",
    "qualifications": "M.Tech.",
    "experience": "24 years",
    "email": "sghalnhiremath@gmail.com",
    "phone": "+91 94486 33855",
    "linkedin": "https://www.linkedin.com/in/s-g-hiremath-347b00413/",
    "areas": [
      "Environmental Engineering"
    ],
    "courses": [
      "Engineering Mechanics",
      "Water Supply And Waste Water Engineering",
      "Solid Waste Management"
    ],
    "publications": 1,
    "projects": 0,
    "bio": "Mr. Siddalingayya Gadigeyya Hiremath is an Assistant Professor in the Department of Civil Engineering at KLS VDIT. He completed his graduation from Karnataka University, Dharwad, in 1999 and earned his postgraduate degree from VTU in 2003. His academic interests and expertise focus on Environmental Engineering and related areas.",
    "irins": "https://klsvdit.irins.org/profile/248699",
    "recognition": [
      "Member of Professional Bodies Institution of Engineers India (IEI)",
      "A member of Indian Society for Technical Education (ISTE)"
    ]
  },
  {
    "id": "f-vijaylaxmi-b-vyakaranahal",
    "name": "Prof. Vijaylaxmi B Vyakaranahal",
    "role": "Assistant Professor",
    "deptId": "civil",
    "image": "/FacultyCImages/vijaylakshmi_vyakarnal_CIVIL.jpeg",
    "qualifications": "M.Tech.",
    "experience": "13 years",
    "email": "vbv@klsvdit.edu.in",
    "phone": "+91 94803 69153",
    "linkedin": "https://www.linkedin.com/in/vijaylaxmi-v-1b51a0242",
    "areas": [
      "Concrete Technology",
      "Alternative Building Materials",
      "Masonry Structures",
      "Sustainable Construction Materials"
    ],
    "courses": [
      "Building Materials And Construction",
      "Concrete Technology",
      "Construction Management",
      "Alternative Building Materials"
    ],
    "publications": 5,
    "projects": 0,
    "bio": "Mrs. Vijaylaxmi B. V. completed her B.E. in Civil Engineering from S.M.C.E.T., Dharwad, and M.Tech. in Structural Engineering from B.V.B.C.E.T., Hubballi. She is currently serving as an Assistant Professor in the Department of Civil Engineering at KLS Vishwanathrao Deshpande Institute of Technology Haliyal. With over a decade of teaching experience, she has been actively involved in teaching. She also serves as the Department Alumni Coordinator and Department Internal Assessment (IA) Coordinator,actively promoting alumni engagement and continuous improvement in teaching-learning processes.",
    "irins": "https://klsvdit.irins.org/profile/248733",
    "recognition": [
      "Member of Professional Bodies A member of Indian Society for Technical Education (ISTE)",
      "Institution of Engineers India (IEI)",
      "All India Council for Technical Education (AICTE)-Quality Improvement Programme (QIP) Postgraduate (PG) Certification Course on Cyber Physical System at Indian Institute of Information Technology (IIIT), Dharwad"
    ]
  },
  {
    "id": "f-seema-basarikatti",
    "name": "Seema Basarikatti",
    "role": "Assistant professor",
    "deptId": "civil",
    "image": "/FacultyCImages/seema_basarikatti_CIVIL.jpeg",
    "qualifications": "M.Tech.",
    "experience": "14 years",
    "email": "srb@klsvdit.edu.in",
    "phone": "+91 78992 30208",
    "linkedin": "https://www.linkedin.com/in/seema-basarikatti-152466250?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "areas": [
      "Water Resource Engineering",
      "Environmental engineering",
      "Hydrology and Hydraulics & Irrigation Engineering"
    ],
    "courses": [
      "Fluid Mechanics",
      "Hydrology And Irrigation Engineering",
      "Engineering Survey",
      "Solid Waste Management"
    ],
    "publications": 2,
    "projects": 4,
    "bio": "Ms. Seema Basarikatti is pursuing her Ph.D at SDMCET Dharwad under VTU. Her research interests are water resource Engineering, Hydrology & Irrigation.",
    "irins": "https://klsvdit.irins.org/profile/248741",
    "recognition": [
      "Member of Indian National Chapter of the International Association of Hydrogeologists (INC-IAH)"
    ]
  },
  {
    "id": "f-laxmi-g-hattiholi",
    "name": "Laxmi G Hattiholi",
    "role": "Assistant Professor and IQAC coordinator",
    "deptId": "civil",
    "image": "/FacultyCImages/laxmi_hattihole_CIVIL.jpeg",
    "qualifications": "M.Tech.",
    "experience": "14 years",
    "email": "iqac@klsvdit.edu.in, lgh@klsvdit.edu.in",
    "phone": "+91 95912 46989",
    "linkedin": "https://in.linkedin.com/in/laxmi-hattiholi-924a882a",
    "areas": [
      "Concrete Technology",
      "Earthquake Engineering",
      "Sustainable Construction Materials",
      "Soil Structure Interaction"
    ],
    "courses": [
      "Concrete Technology",
      "Earthquake Engineering",
      "Design Of Reinforced Concrete (RC) Structural Elements",
      "Prestressed Concrete"
    ],
    "publications": 4,
    "projects": 4,
    "bio": "Prof. Laxmi Hattiholi is an Assistant Professor in the Department of Civil Engineering at KLS VDIT, Haliyal, and serves as the IQAC Coordinator. She is pursuing a Ph.D. with a focus on sustainable construction materials. Passionate about continuous learning and innovation, she actively contributes to teaching, institutional development, and social causes, with a commitment to creating a positive impact on society.",
    "irins": "https://klsvdit.irins.org/profile/259179",
    "recognition": [
      "Member of Professional bodies Institution of Engineers India (IEI)",
      "A member of Indian Society for Technical Education (ISTE)",
      "Received Research grants from Visvesvaraya Technological University (VTU), Karnataka State Council for Science and Technology (KSCST)",
      "Received Indian Green Building Council (IGBC) accredited Faculty award",
      "Completed All India Council for Technical Education (AICTE) Quality Improvement Programme (QIP) Postgraduate (PG) certification course in Cyber security at Indian Institute of Information Technology (IIIT) dharwad"
    ]
  },
  {
    "id": "f-venkatesh-shankar",
    "name": "Dr. Venkatesh Shankar",
    "role": "Professor and HOD",
    "deptId": "cse",
    "image": "/FacultyCImages/DR_venkatesh_shankar_CSE.jpeg",
    "qualifications": "M.Tech., Ph.D.",
    "experience": "16 years",
    "email": "hodcse@klsvdit.edu.in, vss@klsvdit.edu.in",
    "phone": "+91 99641 45566",
    "linkedin": "",
    "areas": [
      "Wireless Sensor Networks (WSN)",
      "Artificial Intelligence and Machine Learning (AIML)",
      "Web Technology",
      "Data Structures"
    ],
    "courses": [
      "Software Engineering",
      "Web Technology",
      "Computer Networks",
      "Machine Learning"
    ],
    "publications": 22,
    "projects": 2,
    "bio": "Dr. Venkatesh Shankar is a Professor and academic leader with a Ph.D. in Wireless Sensor Networks. He is currently guiding seven research scholars, has published four patents, served as IQAC Head and Dean (Academics), and received the Best Teacher Award (2015) at SIT College of Engineering, Ichalkaranji, Maharashtra, for excellence in teaching and academic leadership.",
    "irins": "https://klsvdit.irins.org/profile/259186",
    "recognition": [
      "A member of A member of Indian Society for Technical Education (ISTE)",
      "A member of Computer Society of India (CSI)",
      "A member of Association for Computing Machinery (ACM) member",
      "Board of Studies (BOS) member at Sanjay Bhokare Group of Institutes (SBGI) Miraj",
      "Centre for Development of Advanced Computing (C-DAC) Gold certificate",
      "Visvesvaraya Technological University (VTU) Research Advisory Committee (RAC) member"
    ]
  },
  {
    "id": "f-sunita-kallu",
    "name": "Sunita Kallu",
    "role": "Assistant Professor",
    "deptId": "cse",
    "image": "/FacultyCImages/sunita_kallu_CSE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "8 years",
    "email": "snk@klsvdit.edu.in",
    "phone": "+91 99162 38462",
    "linkedin": "https://www.linkedin.com/in/sunita-kallu-70398",
    "areas": [
      "Wireless Sensors Networks",
      "Computer Networks",
      "Cryptography and Network Security",
      "Artificial intelligence"
    ],
    "courses": [
      "Software Engineering And Project Management",
      "Cloud Computing",
      "Parallel Computing",
      "Database Management Systems"
    ],
    "publications": 0,
    "projects": 0,
    "bio": "Mrs. Sunita Kallu is a faculty member in the Department of Computer Science & Engineering at KLS VDIT. Her research interests include Wireless Sensor Networks and related communication technologies. She is committed to teaching, research, and fostering student learning through practical and innovative approaches.",
    "irins": "https://klsvdit.irins.org/profile/710409",
    "recognition": [
      "A member of Association for Computing Machinery (ACM)"
    ]
  },
  {
    "id": "f-shree-gowri-s-s",
    "name": "Shree Gowri S S",
    "role": "Assistant Professor",
    "deptId": "cse",
    "image": "/FacultyCImages/shreegouri_s_s_CSE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "15 years",
    "email": "sss@klsvdit.edu.in",
    "phone": "+91 80952 07200",
    "linkedin": "https://www.linkedin.com/shreegouri-ss-773276155",
    "areas": [
      "Internet of Things (IoT)",
      "Wireless Sensor Networks"
    ],
    "courses": [
      "Digital Design And Computer Organization",
      "Microcontroller",
      "Internet Of Things",
      "Introduction To C Programming"
    ],
    "publications": 2,
    "projects": 1,
    "bio": "Mrs.Shree Gowri S. S. is working as an Assistant Professor in the Department of Computer Science and Engineering at KLS VDIT. She has been serving since 2010 and is dedicated to teaching and mentoring students. She has handled various subjects in Computer Science and Engineering and strongly believes that hard work, discipline, and continuous learning are the keys to success.",
    "irins": "https://klsvdit.irins.org/profile/249299",
    "recognition": [
      "A member of Indian Society for Technical Education (ISTE)",
      "A member of Institution of Engineers India (IEI) Member",
      "Completed National Programme on Technology Enhanced Learning (NPTEL) Course and attended FDPs (Faculty Development Programmes)"
    ]
  },
  {
    "id": "f-vijet-swadi",
    "name": "Vijet Swadi",
    "role": "Assistant Professor",
    "deptId": "cse",
    "image": "/FacultyCImages/vijet_swadi_CSE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "13 years",
    "email": "vbs@klsvdit.edu.in",
    "phone": "+91 99642 23710",
    "linkedin": "",
    "areas": [
      "Machine Learning",
      "Web tehnology",
      "Natural Language Processin"
    ],
    "courses": [
      "C Programming",
      "Web Technology",
      "Operating System",
      "Software Engineering"
    ],
    "publications": 3,
    "projects": 0,
    "bio": "Mr. Vijet Swadi is an Assistant Professor in the Department of Computer Science and Engineering at KLS VDIT with 13 years of teaching experience. His interests include Machine Learning, Web Technologies, and Natural Language Processing. He teaches Programming, Operating Systems, and Software Engineering, and actively guides innovative student projects and research initiatives.",
    "irins": "",
    "recognition": [
      "information to be updated"
    ]
  },
  {
    "id": "f-pranesh-kulkarni",
    "name": "Pranesh Kulkarni",
    "role": "Assistant Professor",
    "deptId": "cse",
    "image": "/FacultyCImages/pranesh_kulkarni_CSE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "10 years",
    "email": "hodcseds@klsvdit.edu.in, pkk@klsvdit.edu.in",
    "phone": "+91 95387 23414",
    "linkedin": "https://www.linkedin.com/in/pranesh-kulkarni-26bb84a0",
    "areas": [
      "Machine Learning"
    ],
    "courses": [
      "Machine Learning",
      "Object-Oriented Programming (OOP) With C++",
      "Cryptography"
    ],
    "publications": 6,
    "projects": 4,
    "bio": "Mr. Pranesh Kulkarni has a decade of academic experience in the Dept. of CSE at KLS VDIT, Haliyal. He had taught various programming and analytical courses for UG students. He is AWS course instructor.",
    "irins": "https://klsvdit.irins.org/profile/249274",
    "recognition": [
      "Qualified University Grants Commission (UGC) National Eligibility Test (NET) for Assistant Professor in Computer Application",
      "Qualified Graduate Aptitude Test in Engineering (GATE) Data Science and Artificial Intelligence (DA) 2025",
      "Member of Association for Computing Machinery (ACM)",
      "Faculty Development Programme (FDP) Attended - 10",
      "International Conference Attended - 03"
    ]
  },
  {
    "id": "f-girish-n-shivanagudi",
    "name": "Girish N Shivanagudi",
    "role": "Assistant Professor",
    "deptId": "cse",
    "image": "/FacultyCImages/girish_shivanagudi_CSE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "10 years",
    "email": "gns@klsvdit.edu.in",
    "phone": "+91 94493 65221",
    "linkedin": "",
    "areas": [
      "Programming Languages",
      "Web Technologies",
      "Data Structures and Algorithms",
      "Machine Learning"
    ],
    "courses": [
      "Data Structures Using C",
      "Design And Analysis Of Algorithms (DAA)",
      "Java Programming",
      "Python"
    ],
    "publications": 0,
    "projects": 0,
    "bio": "Mr. Girish N S anchors Programming, Web Technologies, Java, and Data Structures courses in the Department of Computer Science & Engineering. With 10 years of teaching experience, he guides students in both theory and laboratory learning",
    "irins": "",
    "recognition": [
      "information to be updated"
    ]
  },
  {
    "id": "f-apoorva-sabnis",
    "name": "Apoorva Sabnis",
    "role": "Assistant Professor",
    "deptId": "cse",
    "image": "/FacultyCImages/apoorva_sabnis_CSE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "1 years",
    "email": "and@klsvdit.edu.in",
    "phone": "+91 76192 81253",
    "linkedin": "https://www.linkedin.com/in/apoorva-sabnis-2ba001160",
    "areas": [
      "Artificial Intelligence (AI)",
      "Machine Learning (ML)",
      "Deep Learning (DL)",
      "Data Science"
    ],
    "courses": [
      "C Programming",
      "Biology For Computer Engineers"
    ],
    "publications": 0,
    "projects": 0,
    "bio": "Mrs. Apoorva Sabnis is a faculty member in the Department of Computer Science & Engineering. Her areas of interest include Artificial Intelligence, Machine Learning, and Data Science. She is passionate about teaching and mentoring students, with a focus on developing practical and analytical skills in emerging technologies. She is committed to fostering innovation and preparing students to address real-world challenges.",
    "irins": "",
    "recognition": [
      "information to be updated"
    ]
  },
  {
    "id": "f-farajanabegaum-nadaf",
    "name": "Farajanabegaum Nadaf",
    "role": "Assistant Professor",
    "deptId": "cse",
    "image": "/FacultyCImages/farajanabegum_nadaf_CSE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "18 years",
    "email": "fnn@klsvdit.edu.in",
    "phone": "+91 99866 85800",
    "linkedin": "https://www.linkedin.com/in/farzana-nadaf-a1794918/",
    "areas": [
      "Internet of Things (IoT)",
      "Big Data Analytics",
      "Cloud Computing",
      "Web Technology"
    ],
    "courses": [
      "Python",
      "Web Programming",
      "Blockchain Technology",
      "Compiler Design"
    ],
    "publications": 4,
    "projects": 6,
    "bio": "Mrs. Farajanabegaum Nadaf is an accomplished academician with 18 years of experience in Computer Science and Engineering, serving as an Assistant Professor. Her expertise includes Data Structures, Internet of Things, Blockchain, and Edge-IoT systems. She is committed to excellence in teaching, research, student mentorship, and industry-oriented learning.",
    "irins": "https://klsvdit.irins.org/profile/249267",
    "recognition": [
      "Appreciated for successfully leading student teams whose projects were shortlisted and funded by Karnataka State Council for Science and Technology (KSCST), demonstrating strong mentorship and research orientation",
      "Short Term Training Programme (STTP) COURSE ON Blockchain Technology,",
      "National Programme on Technology Enhanced Learning (NPTEL) Courses on Internet of Things (IoT),Research Methodology"
    ]
  },
  {
    "id": "f-nirmala-ganiger",
    "name": "Nirmala Ganiger",
    "role": "Assistant Professor",
    "deptId": "cse",
    "image": "/FacultyCImages/nirmala_ganiger_CSE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "6 years",
    "email": "ng@klsvdit.edu.in",
    "phone": "+91 97432 52068",
    "linkedin": "https://www.linkedin.com/in/nirmala-ganiger-1b9a5038?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "areas": [
      "Data Science and Big Data Analytics",
      "Natural Language Processing (NLP)",
      "Quantum Computing",
      "Cloud Computing"
    ],
    "courses": [
      "Uniplexed Information And Computing System (UNIX)",
      "Database Management System",
      "Digital Design And Computer Organization (DDCO)",
      "C Programming"
    ],
    "publications": 5,
    "projects": 1,
    "bio": "Mrs. Nirmala Ganiger is an Assistant Professor in the Department of Computer Science and Engineering at KLS VDIT with six years of teaching experience. Her areas of interest include Artificial Intelligence, Cybersecurity, Data Science, and Software Engineering. She is dedicated to teaching, research, and nurturing students' technical, practical, and innovative skills.",
    "irins": "https://klsvdit.irins.org/profile/564064",
    "recognition": [
      "information to be updated"
    ]
  },
  {
    "id": "f-nancy-p",
    "name": "Nancy P",
    "role": "Assistant Professor",
    "deptId": "cse",
    "image": "/FacultyCImages/Nancy_P_CSE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "14 years",
    "email": "np@klsvdit.edu.in",
    "phone": "+91 94805 94727",
    "linkedin": "https://www.linkedin.com/in/nancy-p-21b4a04061",
    "areas": [
      "Computer Science and Engineering department",
      "Artificial intelligence"
    ],
    "courses": [
      "Big Data Analysis",
      "Microcontroller ( 2 Div)",
      "Social Connect And Responsibility"
    ],
    "publications": 1,
    "projects": 0,
    "bio": "Mrs. Nancy P. is an Assistant Professor in the Department of Computer Science and Engineering at KLS VDIT. Her academic interests include Artificial Intelligence, Big Data Analytics, and Microcontrollers. She actively coordinates student activities, contributes to academic development, and is committed to fostering innovation, social responsibility, and student success.",
    "irins": "",
    "recognition": [
      "Received appreciation letter from Head of Institution (HOI) for big Data analytics for students feedback",
      "Mtech in Electronics and Communication Engineering (EC)"
    ]
  },
  {
    "id": "f-bhagat-inamdar",
    "name": "Bhagat Inamdar",
    "role": "Assistant Professor",
    "deptId": "cse",
    "image": "/FacultyCImages/bhagat_inamdar_CSE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "3 years",
    "email": "bgi@klsvdit.edu.in",
    "phone": "+91 98800 89908",
    "linkedin": "https://www.linkedin.com/in/bhagat-inamdar-57638055/",
    "areas": [
      "Computer Network"
    ],
    "courses": [
      "Computer Networks",
      "Database Management System (DBMS)",
      "C++"
    ],
    "publications": 4,
    "projects": 1,
    "bio": "Mr. Bhagat Inamdar is an Assistant Professor in the Department of Computer Science & Engineering at KLS Vishwanathrao Deshpande Institute of Technology, Haliyal. His areas of interest include Wireless Sensor Networks, Network Routing Algorithms, and Cyber Security.",
    "irins": "https://klsvdit.irins.org/profile/483123",
    "recognition": [
      "Member of professional bodies including Computer Society of India (CSI)",
      "Association for Computing Machinery (ACM)"
    ]
  },
  {
    "id": "f-poornima-raikar",
    "name": "Dr. Poornima Raikar",
    "role": "Assistant Professor & Head of Department",
    "deptId": "cse-aiml",
    "image": "/FacultyCImages/DR_poornima_raikar_AIML.jpeg",
    "qualifications": "M.Tech., Ph.D.",
    "experience": "21 years",
    "email": "hodcseaiml@klsvdit.edu.in, pnr@klsvdit.edu.in",
    "phone": "+91 96115 17345",
    "linkedin": "https://www.linkedin.com/in/poornima-raikar-1696851b2?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "areas": [
      "Image processing",
      "Artificial Intelligence"
    ],
    "courses": [
      "Theory Of Computation",
      "Software Engineering",
      "Problem Solving In C",
      "C++"
    ],
    "publications": 15,
    "projects": 4,
    "bio": "Dr. Poornima Raikar is the Head of the Department of Computer Science and Engineering (AI & ML) at KLS VDIT. With over 21 years of teaching and research experience, her expertise includes Image Processing and Artificial Intelligence. She is committed to academic excellence, innovation, research, student mentoring, and professional development.",
    "irins": "https://klsvdit.irins.org/profile/249264",
    "recognition": [
      "Best women Karnatak Law Society (KLS) achiever 2015, Information and Communication Technology (ICT) academy Best Single Point of Contact (SPOC) award"
    ]
  },
  {
    "id": "f-ekata-shanbhag",
    "name": "Ekata Shanbhag",
    "role": "Assistant Professor",
    "deptId": "cse-aiml",
    "image": "/FacultyCImages/ekata_shanbhag_AIML.jpeg",
    "qualifications": "M.Tech.",
    "experience": "3 years",
    "email": "ess@klsvdit.edu.in",
    "phone": "+91 96208 28376",
    "linkedin": "https://www.linkedin.com/in/ekata-shanbhag-06b895401/?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3B2GUGPCLKQgi%2Fh9E6OS2njA%3D%3D",
    "areas": [
      "Computer Network",
      "Machine Learning"
    ],
    "courses": [
      "Analysis And Design Of Algorithms (ADA)",
      "Hypertext Preprocessor (PHP)",
      "Database Management System (DMS)",
      "Data Structures"
    ],
    "publications": 4,
    "projects": 0,
    "bio": "Mrs. Ekata Shanbhag is an Assistant Professor in the Department of Computer Science and Engineering (AI & ML) at KLS VDIT. Her areas of expertise include Algorithms Design and Analysis, Data Structures, UNIX, Python, and PHP.",
    "irins": "https://klsvdit.irins.org/profile/441249",
    "recognition": [
      "Faculty Development Programme (FDP)-5",
      "National Programme on Technology Enhanced Learning (NPTEL) -1"
    ]
  },
  {
    "id": "f-amarnath-swami",
    "name": "Amarnath Swami",
    "role": "Assistant Professor",
    "deptId": "cse-aiml",
    "image": "/FacultyCImages/amarnath_swami_AIML.jpeg",
    "qualifications": "M.Tech.",
    "experience": "1 years",
    "email": "as@klsvdit.edu.in",
    "phone": "+91 63605 42457",
    "linkedin": "https://www.linkedin.com/in/amarnathswami",
    "areas": [
      "Machine Learning",
      "Data Mining and Data Analytics",
      "Cloud Computing and Big data analytics"
    ],
    "courses": [
      "Machine Learning",
      "Machine Learning -2",
      "Theory Of Computation"
    ],
    "publications": 3,
    "projects": 0,
    "bio": "Mr. Amarnath Swami is an Assistant Professor in the Department of Computer Science and Engineering (AI & ML) at KLS VDIT. His academic interests include Artificial Intelligence, Machine Learning, Cyber Security, and Data Engineering. He actively mentors students and promotes practical, industry-oriented learning approaches.",
    "irins": "",
    "recognition": [
      "information to be updated"
    ]
  },
  {
    "id": "f-narasimha-dixit",
    "name": "Narasimha Dixit",
    "role": "Assistant Professor",
    "deptId": "cse-aiml",
    "image": "/FacultyCImages/narasimha_dixit_AIML.jpeg",
    "qualifications": "M.Tech.",
    "experience": "3 years",
    "email": "nkd@klsvdit.edu.in",
    "phone": "+91 91130 59363",
    "linkedin": "https://www.linkedin.com/in/narasimha-dixit-2b9237267?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "areas": [
      "Artificial Intelligence (AI) and Machine Learning (ML)",
      "Natural Language Processing (NLP)",
      "Cyber Security"
    ],
    "courses": [
      "Artificial Intelligence",
      "Deep Learning",
      "Analysis And Design Of Algorithms",
      "Object-Oriented Programming System (OOPS) With Java"
    ],
    "publications": 3,
    "projects": 0,
    "bio": "Mr. Narasimha Dixit is an Assistant Professor in the Department of Computer Science & Engineering (Artificial Intelligence & Machine Learning). His areas of interest include Artificial Intelligence, Machine Learning, Natural Language Processing, Deep Learning, and Cyber Security. He has successfully guided four undergraduate projects and actively contributes to research and innovation in emerging technologies. He has published one patent and three research papers in journals. As a member of ACM, he is committed to advancing education and research.",
    "irins": "",
    "recognition": [
      "Member of Association for Computing Machinery (ACM)"
    ]
  },
  {
    "id": "f-bheerappa-sasanoor",
    "name": "Bheerappa Sasanoor",
    "role": "Assistant Professor",
    "deptId": "cse-aiml",
    "image": "/FacultyCImages/bheerappa_sasnoor_AIML.jpeg",
    "qualifications": "M.Tech.",
    "experience": "6 years",
    "email": "bys@klsvdit.edu.in",
    "phone": "+91 70196 27017",
    "linkedin": "https://www.linkedin.com/in/bheerappa-sasanoor-6570a364/",
    "areas": [
      "Cloud",
      "Network Security"
    ],
    "courses": [
      "Computer Network",
      "Data Base Management",
      "Digital Design And Computer Organization"
    ],
    "publications": 0,
    "projects": 0,
    "bio": "Mr. Bheerappa Sasanur is an Assistant Professor in the Department of Computer Science and Engineering (AI & ML) at KLS VDIT with six years of teaching experience. He holds an M.Tech in Computer Science and Engineering and is currently pursuing a Ph.D. at VTU.",
    "irins": "",
    "recognition": [
      "information to be updated"
    ]
  },
  {
    "id": "f-kanchan-khokale",
    "name": "Kanchan Khokale",
    "role": "Assistant Professor",
    "deptId": "cse-aiml",
    "image": "/FacultyCImages/kanchan_khokale_AIML.jpeg",
    "qualifications": "M.Tech.",
    "experience": "0.5 years",
    "email": "kmk@klsvdit.edu.in",
    "phone": "+91 63624 23062",
    "linkedin": "",
    "areas": [
      "Image Processing"
    ],
    "courses": [
      "C Programming",
      "Introduction To Artificial Intelligence (AI)",
      "Microcontrollers & Embedded Systems"
    ],
    "publications": 0,
    "projects": 0,
    "bio": "Mr. Kanchan Khokale is an Assistant Professor in the Department of Computer Science and Engineering (AI & ML) at KLS VDIT. Her expertise includes programming languages such as C, Python, and Java. Her research interests focus on Image Processing, and she is dedicated to teaching, mentoring students, and developing problem-solving skills.",
    "irins": "",
    "recognition": [
      "information to be updated"
    ]
  },
  {
    "id": "f-ravindra-patil",
    "name": "Ravindra Patil",
    "role": "Assistant Professor",
    "deptId": "cse-aiml",
    "image": "/FacultyCImages/ravindra_patil_AIML.jpeg",
    "qualifications": "M.Tech.",
    "experience": "14 years",
    "email": "rtp@klsvdit.edu.in",
    "phone": "+91 89719 48465",
    "linkedin": "",
    "areas": [
      "Cryptography and Computer Networking"
    ],
    "courses": [
      "Machine Learning",
      "Cryptography",
      "Computer Network",
      "C Programming"
    ],
    "publications": 4,
    "projects": 2,
    "bio": "Ravindra Patil has been serving in the Department of Computer Science & Engineering since 2012. Currently pursuing a Ph.D., while actively contributing to teaching, academic mentoring, and research in Computer Science and Engineering.",
    "irins": "https://klsvdit.irins.org/profile/249282",
    "recognition": [
      "Received the \"Best Student's Teacher\" Award for the Academic Year 2014-15 in recognition of outstanding contribution to student development and academic excellence",
      "Member of professional bodies including Association for Computing Machinery (ACM)",
      "A member of Indian Society for Technical Education (ISTE)"
    ]
  },
  {
    "id": "f-jyoti-chitti",
    "name": "Jyoti Chitti",
    "role": "Assistant Professor",
    "deptId": "cse-aiml",
    "image": "/FacultyCImages/jyoti_chitti_AIML.jpeg",
    "qualifications": "M.Tech.",
    "experience": "8 years",
    "email": "jsc@klsvdit.edu.in",
    "phone": "+91 96328 88053",
    "linkedin": "https://in.linkedin.com/in/jyothi-s-73508935a",
    "areas": [
      "Blockchain technology,",
      "Computer Network and security,",
      "Natural Language Processing,",
      "Cybersecurity"
    ],
    "courses": [
      "Design And Analysis Of Algorithm",
      "Programming In C",
      "Big Data Analytics",
      "Operating System"
    ],
    "publications": 0,
    "projects": 0,
    "bio": "Mrs. Jyoti Chitti serves as an Assistant Professor in the Department of Computer Science and Engineering (AI & ML) at KLS VDIT, Haliyal. She handles core engineering subjects and focuses on delivering quality education while fostering student learning and development.",
    "irins": "",
    "recognition": [
      "Received Excellence award in Edunet Foundation",
      "1 Completed National Programme on Technology Enhanced Learning (NPTEL) courses like (Internet of Things (IoT), Cyber security, AI)",
      "Attended FDPs (Faculty Development Programmes) on Generative Artificial Intelligence (AI), Cybersecurity, Internet of Things (IoT) and Amazon Web Services (AWS)",
      "Presented paper on Internet of Things (IoT) based patient vitals and medicine storage monitoring with blockchain security at International Conference on Computational Intelligence and Communication (ICCIC) 2025",
      "Worked asTechnical master trainer at Edunet Foundation"
    ]
  },
  {
    "id": "f-rajeshwari-nanannavar",
    "name": "Mrs. Rajeshwari Nanannavar",
    "role": "Assistant Professor & Head",
    "deptId": "eee",
    "image": "/FacultyCImages/rajeshwari_nannavar_EEE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "14 years",
    "email": "hodeee@klsvdit.edu.in, rbn@klsvdit.edu.in",
    "phone": "+91 63632 76278",
    "linkedin": "https://www.linkedin.com/in/rajeshwari-nanannavar-200583413?trk=contact-info",
    "areas": [
      "Power Systems",
      "Energy Systems"
    ],
    "courses": [
      "Power System Operation & Control",
      "Power System Protection",
      "Control Systems",
      "Operational Amplifiers & Linear Ics (Integrated Circuits)"
    ],
    "publications": 3,
    "projects": 2,
    "bio": "Mrs. Rajeshwari Nanannavar is the Head of the Department of Electrical & Electronics Engineering at KLS VDIT, Haliyal. Her research interests encompass Power Systems and Energy Systems. She is also an active member of the Institution of Engineers(India) - IEI.",
    "irins": "https://klsvdit.irins.org/profile/248937",
    "recognition": [
      "Member-Institution of Engineers India (IEI)"
    ]
  },
  {
    "id": "f-ravindra-motekar",
    "name": "Ravindra Motekar",
    "role": "Assistant Professor",
    "deptId": "eee",
    "image": "/FacultyCImages/ravindra_motekar_EEE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "10 years",
    "email": "rsm@klsvdit.edu.in",
    "phone": "+91 97384 72638",
    "linkedin": "https://www.linkedin.com/in/ravi-motekar-3a472072",
    "areas": [
      "Industrial Electronics",
      "Smart Grid",
      "Integration of Renewable Energy",
      "Power Quality"
    ],
    "courses": [
      "Analog Electronic Circuits",
      "Microcontroller",
      "Introduction To Electrical Engineering",
      "Energy Audit And Demand Side Management (DSM)"
    ],
    "publications": 5,
    "projects": 1,
    "bio": "Prof. Ravindra Motekar is serving as an Assistant Professor in the Department of Electrical and Electronics Engineering at KLS VDIT, Haliyal, with over 11 years of teaching experience. He holds an M.Tech in Industrial Electronics and is currently pursuing a Ph.D. at R.V. College of Engineering, Bangalore. His areas of interest include Industrial Electronics, Smart Grid, Renewable Energy Systems and Power Quality. He is actively involved in academic mentoring, departmental activities, and fostering industry-oriented learning among students.",
    "irins": "https://klsvdit.irins.org/profile/248939",
    "recognition": [
      "Member of professional bodies including Institution of Engineers India (IEI)",
      "Received Karnataka State Council for Science and Technology (KSCST) funding worth Rs 6000/- for Undergraduate (UG) project in year 2021-22",
      "Industrial Experience of 2 years at Wipro Technologies Pune",
      "Institute Level Massive Open Online Course (MOOC) Coordinator",
      "Institute Level Newsletter Coordinator",
      "Department Training & Placement Coordinator",
      "Department Alumni Coordinator",
      "Cultural Coordinator",
      "4th Year Class Teacher"
    ]
  },
  {
    "id": "f-arun-l-kakhandki",
    "name": "Dr. Arun L. Kakhandki",
    "role": "Professor",
    "deptId": "eee",
    "image": "/FacultyCImages/DR_arun_kakhandki_EEE.jpeg",
    "qualifications": "M.Tech., Ph.D.",
    "experience": "30 years",
    "email": "alk@klsvdit.edu.in",
    "phone": "+91 98808 41628",
    "linkedin": "https://www.linkedin.com/in/dr-arun-kakhandki-85a292169",
    "areas": [
      "Wireless Sensor Networks (WSN)",
      "Signal Processing",
      "Very Large Scale Integration (VLSI)",
      "Embedded Systems"
    ],
    "courses": [
      "Computer Communication Networks",
      "Wireless Sensor Networks",
      "Digital System Design",
      "Embedded System Design"
    ],
    "publications": 30,
    "projects": 3,
    "bio": "Dr. Arun L. Kakhandki has over 26 years of teaching experience in E&C and E&E engineering. His research focuses on WSN, Signal Processing, VLSI & Embedded Systems. Two scholars were awarded Ph.D. under his guidance, and six are pursuing. He has more than thirty publications to his credit. He is a senior member of IEEE and also a member of IETE, IEI & ISTE. He is the IEEE Student Branch Counselor of the institute.",
    "irins": "https://klsvdit.irins.org/profile/249322",
    "recognition": [
      "Research grants worth nearly Rs. 4L in the last 5 years",
      "Reviewer for peer-reviewed journals",
      "Member of professional bodies including Institute of Electrical and Electronics Engineers (IEEE)",
      "Institution of Electronics and Telecommunication Engineers (IETE)",
      "Institution of Engineers India (IEI)",
      "A member of Indian Society for Technical Education (ISTE)",
      "Fellow, Institution of Electronics and Telecommunication Engineers (Institution of Electronics and Telecommunication Engineers (IETE)) (F-503222)",
      "Senior Member, Institute of Electrical and Electronics Engineers (IEEE)",
      "Life Member, A member of Indian Society for Technical Education (ISTE) (LM35179)",
      "Member, Institution of Engineers (IE) (AM094148-7)",
      "Institute of Electrical and Electronics Engineers (IEEE) Student Branch Counselor for the year 2023, 2024, 2025 &",
      "Member, Life Insurance Corporation (LIC), Visvesvaraya Technological University (VTU), for the year",
      "Member, BoE, Electronics and Communication (EC) Board, Visvesvaraya Technological University (VTU), for the Academic Year (AY) 2020-21",
      "Funded project from New Age Innovation Network (NAIN), Karnataka Technology (K-Tech), Government of Karnataka (GoK)"
    ]
  },
  {
    "id": "f-varaprasad-gaonkar",
    "name": "Varaprasad Gaonkar",
    "role": "Assistant Professor",
    "deptId": "eee",
    "image": "/FacultyCImages/varaprasad_gaonkar_EEE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "14 years",
    "email": "vgg@klsvdit.edu.in",
    "phone": "+91 89711 46518",
    "linkedin": "https://www.linkedin.com/in/varaprasad-gaonkar-55300557?trk=contact-info",
    "areas": [
      "Power System Congestion Management",
      "Flexible AC Transmission Systems (FACTS)",
      "Power System Stability Improvement using Flexible AC Transmission Systems (FACTS)"
    ],
    "courses": [
      "Power System Analysis,",
      "Control Systems,",
      "Electric Circuit Analysis,",
      "Electric Motors"
    ],
    "publications": 3,
    "projects": 4,
    "bio": "Mr.Varaprasad Gaonkar is an Assistant Professor in the Department of Electrical and Electronics Engineering, currently pursuing a Ph.D. in Power System Congestion Management from VTU.",
    "irins": "https://klsvdit.irins.org/profile/248936",
    "recognition": [
      "Received sponsership of 25k from New Age Innovation Network (NAIN) for innovative project",
      "Member of Institution of Engineers India (IEI)"
    ]
  },
  {
    "id": "f-manjunatha",
    "name": "Manjunatha",
    "role": "Assistant Professor",
    "deptId": "eee",
    "image": "/FacultyCImages/manjunatha_d_EEE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "28 years",
    "email": "deanadmin@klsvdit.edu.in",
    "phone": "+91 98801 38746",
    "linkedin": "https://www.linkedin.com/in/manjunatha-dollin-358177202",
    "areas": [
      "Energy Management",
      "Energy Conservation",
      "Electrical Machines and",
      "Electrical Measurements"
    ],
    "courses": [
      "Electrical Machines - Alternating Current (AC) And Direct Current (DC)",
      "Electrical And Electronics Measurements",
      "Testing And Commissioning Of Power System Equipment"
    ],
    "publications": 1,
    "projects": 0,
    "bio": "Mr. Manjunatha is a senior academician with extensive teaching, industry, and administrative experience. Since joining KLS VDIT in 2005, he has played a pivotal role in strengthening academic infrastructure and departmental growth. He served as Head of the Department for 16 years and currently holds the position of Dean (Administration).",
    "irins": "https://klsvdit.irins.org/profile/248912?utm",
    "recognition": [
      "Life Member of A member of Indian Society for Technical Education (ISTE)",
      "Fellow of the Institution of Engineers (FIE) of Institute of Engineers",
      "International Association of Engineers",
      "Teaching Faculty , Dean admin"
    ]
  },
  {
    "id": "f-prakash-laxman-chavan",
    "name": "Prakash Laxman Chavan",
    "role": "Assistant Professor",
    "deptId": "eee",
    "image": "/FacultyCImages/prakash_chavan_EEE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "15 years",
    "email": "plc@klsvdit.edu.in",
    "phone": "+91 73874 73539",
    "linkedin": "https://www.linkedin.com/in/prakash-chavan-89146457/",
    "areas": [
      "Power and Energy Systems",
      "Renewable Energy Sources",
      "Power Electronics and Electric Drives"
    ],
    "courses": [
      "Power Electronics",
      "Industrial Drives And Control",
      "Electric Machines"
    ],
    "publications": 20,
    "projects": 0,
    "bio": "Prof. Prakash Chavan is an academician and researcher in Electrical Engineering, currently associated with Karnatak Law Society's Vishwanathrao Deshpande Institute of Technology. His areas of interest include power systems, renewable energy, power quality, and engineering education. He actively contributes to research, professional societies, student development, and technical innovation through teaching, publications, and IEEE-related activities.",
    "irins": "",
    "recognition": [
      "Institute of Electrical and Electronics Engineers (IEEE) Professional Member, Professional Learning and Employment Skills (PLES) Faculty Advisor"
    ]
  },
  {
    "id": "f-sheetal-n-mindolkar",
    "name": "Sheetal N. Mindolkar",
    "role": "Assistant Professor",
    "deptId": "eee",
    "image": "/FacultyCImages/sheetal_mindolkar_EEE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "2.8 years",
    "email": "snm@klsvdit.edu.in",
    "phone": "+91 95359 98588",
    "linkedin": "https://www.linkedin.com/in/sheetal-mindolkar-133sh6226",
    "areas": [
      "Industrial Electronics",
      "Smart Grid"
    ],
    "courses": [
      "Signals And Digital Signal Processing (DSP)",
      "High Voltage (HV) And Power System Protection",
      "Switchgear And Protection",
      "Control System Lab"
    ],
    "publications": 1,
    "projects": 0,
    "bio": "Ms.Sheetal N. Mindolkar is serving as an Assistant Professor in the Department of Electrical and Electronics Engineering at KLS VDIT, Haliyal, with over 2.8 years of teaching experience. She holds an M. Tech in Industrial Electronics and is passionate about teaching, mentoring, and continuous learning. Her areas of interest include power systems, signal processing, and control systems. She is committed to imparting both theoretical and practical knowledge while fostering innovation, critical thinking, and problem-solving skills among students.",
    "irins": "https://klsvdit.irins.org/profile/441261",
    "recognition": [
      "Active participant in academic and departmental responsibilities.",
      "Dedicated mentor guiding students in projects and technical activities and continuously strives to promote innovation and outcome based learning in Electrical and Electronics Engineering",
      "Department Level Project Coordinator",
      "Department Level Enterprise Resource Planning (ERP) Coordinator",
      "Department Level Newsletter Coordinator",
      "Antiragging Squad"
    ]
  },
  {
    "id": "f-kirankumar-hittanagi",
    "name": "Kirankumar Hittanagi",
    "role": "Assistant Professor",
    "deptId": "eee",
    "image": "/FacultyCImages/kiran_hittanagi_EEE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "10 years",
    "email": "knh@klsvdit.edu.in",
    "phone": "+91 95917 03781",
    "linkedin": "https://www.linkedin.com/in/prof-kirankumar-hittanagi-27101990",
    "areas": [
      "Integrated Renewable Energy Sources",
      "Power Electronics and Electric Motor Drives"
    ],
    "courses": [
      "Power Electronics",
      "Industrial Drives And Applications",
      "Introduction To Electrical Engineering",
      "Sensors And Transducers"
    ],
    "publications": 4,
    "projects": 1,
    "bio": "Mr. Kirankumar Hittanagi serves as an Assistant Professor in the Department of Electrical and Electronics Engineering at KLS VDIT. His areas of interest and research include Integrated Renewable Energy Sources, Power Electronics, and Electric Motor Drives. He is currently pursuing Ph.D. in the field of Electrical Engineering with a focus on advancing sustainable and efficient energy systems.",
    "irins": "https://klsvdit.irins.org/profile/248941",
    "recognition": [
      "Awarded Elite + Gold certification in 12-week National Programme on Technology Enhanced Learning (NPTEL) Online Certification on course titled Smart Grid: Basics to Advanced Technologies by National Programme on Technology Enhanced Learning (NPTEL) (2026)",
      "Received the sponsorship of Rs. 50,000/- from Karnataka Renewable Energy Development Limited (KREDL), Bengaluru for organizing activities on Energy Conservation (2024-25)",
      "Received the grant of Rs. 6000/- from Karnataka State Council for Science and Technology (KSCST) for student project titled \"Internet of Things (IoT) Based Efficiency Monitoring System for Domestic Bio-Gas Plant\" (2020-21)",
      "Successfully completed the National Programme on Technology Enhanced Learning (NPTEL) Online Certification on Research Methodology,",
      "Successfully completed the Certificate Programme on Renewable Energy & Net Zero by Confederation of Indian Industry (Confederation of Indian Industry (CII)), Hyderabad during Feb-2025",
      "Energy Cell Incharge"
    ]
  },
  {
    "id": "f-rajeshwari-pashupatimath",
    "name": "Mrs. Rajeshwari Pashupatimath",
    "role": "Assistant Professor",
    "deptId": "ece",
    "image": "/FacultyCImages/rajeshwari_pashupatimath_ECE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "2years 5 months",
    "email": "rap@klsvdit.edu.in",
    "phone": "+91 63626 85217",
    "linkedin": "https://www.linkedin.com/in/rajeshwari-pashupatimath-83890b413?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "areas": [
      "Image Processing"
    ],
    "courses": [
      "Microcontroller",
      "Digital Communication"
    ],
    "publications": 2,
    "projects": 0,
    "bio": "Mrs. Rajeshwari Pashupatimath serves as an Assistant Professor in the Department of Electronics and Communication Engineering (E&CE) at KLS VDIT, Haliyal. Her academic and research interests are centered on Image Processing, with a focus on exploring innovative techniques and applications in the field. She is currently pursuing her Ph.D. as a Research Scholar at KLS VDIT, Haliyal, contributing to research in advanced image processing technologies. She is actively involved in teaching, mentoring students, and engaging in research activities that bridge theoretical concepts with practical applications in Electronics and Communication Engineering.",
    "irins": "https://vapt6.irins.org/profile-detail/1000061",
    "recognition": [
      "Authored and co-authored research papers in reputed national and international journals and conferences",
      "Serving as the Institutional Coordinator for Indian Science, Technology and Engineering facilities Map (I-STEM), facilitating research infrastructure sharing and collaboration",
      "Working as the Karnataka Science and Technology Academy (KSTA) Coordinator, promoting scientific awareness, innovation, and technology-driven activities among students and faculty",
      "Ambassador of Institution Innovation Council (IIC)",
      "Coordinator of Indian Science Technology and Engineering facilities Map (I-STEM)",
      "Research Scholar",
      "Coordinator of Karnataka Science and Technology Academy (KSTA)"
    ]
  },
  {
    "id": "f-raghavendra-nagaralli",
    "name": "Mr. Raghavendra Nagaralli",
    "role": "Assistant Professor",
    "deptId": "ece",
    "image": "/FacultyCImages/raghavendra_nagaralli_ECE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "13 years",
    "email": "rpn@klsvdit.edu.in",
    "phone": "+91 97420 76542",
    "linkedin": "https://www.linkedin.com/in/raghavendra-nagaralli9/",
    "areas": [
      "Deep learning",
      "Image Processing",
      "Machine Learning"
    ],
    "courses": [
      "Computer Communication Networking",
      "Network Security",
      "Operating System",
      "Computer Organization"
    ],
    "publications": 5,
    "projects": 2,
    "bio": "Mr. Raghavendra Nagaralli is an Assistant Professor in the Department of Electronics and Communication Engineering at KLS VDIT. His research focuses on the application of Deep Learning algorithms in Image Processing. His areas of interest include Artificial Intelligence, Machine Learning, and Deep Learning, contributing to innovative research and technological advancements.",
    "irins": "https://klsvdit.irins.org/profile/249315",
    "recognition": [
      "Successfully completed All India Council for Technical Education (AICTE) Quality Improvement Programme (QIP) Postgraduate (PG) CERTIFICATION PROGRAMME in CYBER PHYSICAL SYSTEM from Indian Institute of Information Technology (IIIT) DHARWAD during June - Dec 2025"
    ]
  },
  {
    "id": "f-pavitra-m-badiger",
    "name": "Ms. Pavitra M Badiger",
    "role": "Assistant Professor",
    "deptId": "ece",
    "image": "/FacultyCImages/pavitra_badiger_ECE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "2.5 years",
    "email": "pmb@klsvdit.edu.in",
    "phone": "+91 89040 17520",
    "linkedin": "https://www.linkedin.com/in/pavitra-badiger-664b78377?trk=contact-info",
    "areas": [
      "Image processing"
    ],
    "courses": [
      "Computer Networks And Protocols",
      "Destination-Sequenced Distance Vector (DSDV)"
    ],
    "publications": 6,
    "projects": 1,
    "bio": "Ms. Pavitra M. Badiger is an Assistant Professor in the Department of Electronics and Communication Engineering at KLS VDIT since 2023. She is currently pursuing Ph.D. research in Image Processing under VTU. Her research work has been presented at an international conference, reflecting her commitment to academic excellence and research advancement.",
    "irins": "https://klsvdit.irins.org/profile/441310#personal_information_panel",
    "recognition": [
      "Working as Assistant Professor in Electronics and Communication Engineering (E&CE) department",
      "Department Internal Assessment (IA) coordinator",
      "Departments mentoring / Counseling coordinator",
      "Institution Innovation Council (IIC) ambassador",
      "Research scholar of the college"
    ]
  },
  {
    "id": "f-sudheendra-yalagur",
    "name": "Mr. Sudheendra Yalagur",
    "role": "Assistant Professor",
    "deptId": "ece",
    "image": "/FacultyCImages/sudhindra_yalagur_ECE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "15 years",
    "email": "shy@klsvdit.edu.in",
    "phone": "+91 97383 47968",
    "linkedin": "http://www.linkedin.com/in/sudheendra-yalagur-39645818",
    "areas": [
      "Embedded Systems",
      "Signal Processing",
      "Computer Networks",
      "Wireless Communication"
    ],
    "courses": [
      "Network Analysis",
      "Digital Signal Processing",
      "Embedded Systems",
      "Control Systems"
    ],
    "publications": 3,
    "projects": 0,
    "bio": "Mr. Sudheendra Yalagur is an Assistant Professor in the Department of Electronics and Communication Engineering at KLS VDIT. His academic interests include Embedded Systems, Signal Processing, Computer Networks, and Wireless Communication. He is passionate about teaching, research, and mentoring students, fostering innovation, critical thinking, and practical problem-solving skills.",
    "irins": "",
    "recognition": [
      "PROJECT BATCHES RECEIVED Karnataka State Council for Science and Technology (KSCST) PROJECT GRANTS UNDER MY GUIDENCE"
    ]
  },
  {
    "id": "f-ashwini-garaddi",
    "name": "Mrs. Ashwini Garaddi",
    "role": "Assistant Professor",
    "deptId": "ece",
    "image": "/FacultyCImages/ashwini_garaddi_ECE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "2 years",
    "email": "asg@klsvdit.edu.in",
    "phone": "+91 88846 41965",
    "linkedin": "https://www.linkedin.com/in/ashwini-garaddi-b50973339?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "areas": [
      "Antenna Design",
      "Communication subsystem design"
    ],
    "courses": [
      "Network Security",
      "Wireless Communication System",
      "Microcontroller",
      "Hybrid Electric Vehicles"
    ],
    "publications": 3,
    "projects": 0,
    "bio": "Mrs. Ashwini Garaddi completed M. Tech. from KLS VDIT and is pursuing Ph.D. from AMC Engineering College, Bengaluru under VTU. Her research areas are Antenna design, communication subsystem design.",
    "irins": "https://vidwan.inflibnet.ac.in/profile/563950",
    "recognition": [
      "Completed National Programme on Technology Enhanced Learning (NPTEL) Courses, published patent on antenna",
      "Project coordinator",
      "Enterprise Resource Planning (ERP) coordinator",
      "Institution Innovation Council (IIC) Innovation Ambassador"
    ]
  },
  {
    "id": "f-jyoti-kammar",
    "name": "Mrs. Jyoti Kammar",
    "role": "Assistant Professor",
    "deptId": "ece",
    "image": "/FacultyCImages/jyothi_kammar_ECE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "1 years",
    "email": "jsk@klsvdit.edu.in",
    "phone": "+91 98456 23368",
    "linkedin": "https://www.linkedin.com/in/jyoti-kammar-a54630393",
    "areas": [
      "Power System"
    ],
    "courses": [
      "Electric Circuit Analysis",
      "Wireless Communication System",
      "Control System",
      "Electromagnetic Theory"
    ],
    "publications": 0,
    "projects": 0,
    "bio": "Mrs. Jyoti Kammar is an Assistant Professor in the Department of Electronics and Communication Engineering at KLS VDIT. She actively contributes to teaching, student development, and institutional initiatives. She serves as Coordinator of the Red Cross and Red Ribbon Club, Department Website Coordinator, and IIIC Ambassador. Her area of interest is Power Systems.",
    "irins": "https://vapt6.irins.org/profile-detail/1000062",
    "recognition": [
      "Published Patent, Completed National Programme on Technology Enhanced Learning (NPTEL) Courses",
      "Red cross and red ribbon Club coordinator",
      "Institution Innovation Council (IIC) innovation Ambassador",
      "Website Coordinator"
    ]
  },
  {
    "id": "f-nikhil-a-kulkarni",
    "name": "Mr. Nikhil A. Kulkarni",
    "role": "Assistant Professor",
    "deptId": "ece",
    "image": "/FacultyCImages/nikhil_kulkarni_ECE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "14 years",
    "email": "nak@klsvdit.edu.in",
    "phone": "+91 96113 61637",
    "linkedin": "https://www.linkedin.com/in/nikhil-kulkarni-7b4204112/",
    "areas": [
      "Embedded Systems",
      "Very Large Scale Integration (VLSI) Design",
      "Digital Electronics",
      "Field Programmable Gate Array (FPGA) and Application Specific Integrated Circuit (ASIC) Design"
    ],
    "courses": [
      "Embedded System Design",
      "Network Analysis",
      "Electromagnetics",
      "VHSIC Hardware Description Language (VHDL) And Verilog"
    ],
    "publications": 10,
    "projects": 3,
    "bio": "Mr. Nikhil A. Kulkarni holds an M.Tech in VLSI Design and Embedded Systems and a B.E. in Electronics and Communication Engineering. His areas of interest include Embedded Systems, VLSI Design, Digital Electronics, and FPGA-Based System Design. He is actively involved in teaching, research, and technology-driven learning in the field of Electronics and Communication Engineering.",
    "irins": "https://klsvdit.irins.org/profile/249320",
    "recognition": [
      "National Programme on Technology Enhanced Learning (NPTEL)",
      "Indian Institute of Technology (IIT) Bombay Spoken Tutorial and National Programme on Technology Enhanced Learning (NPTEL) Coordinator"
    ]
  },
  {
    "id": "f-pooja-c-shindhe",
    "name": "Ms. Pooja C Shindhe",
    "role": "Assistant Professor",
    "deptId": "ece",
    "image": "/FacultyCImages/pooja_shinde_ECE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "4 years",
    "email": "pcs@klsvdit.edu.in",
    "phone": "+91 93539 88748",
    "linkedin": "https://www.linkedin.com/in/pooja-shindhe-261343159?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "areas": [
      "Image Processing/ compression",
      "Multimedia Communication"
    ],
    "courses": [
      "Network Analysis",
      "Microwave And Antenna Theory",
      "Electromagnetic Theory",
      "Multimedia Communication"
    ],
    "publications": 6,
    "projects": 0,
    "bio": "Ms.Pooja Shindhe serves as an Assistant Professor in the Department of Electronics and Communication Engineering at KLS VDIT. Her research interests include image compression and related signal processing techniques. She is actively involved in promoting innovation and entrepreneurship as an Innovation Ambassador under Institution's Innovation Council (IIC), contributing to academic excellence and student development.",
    "irins": "https://klsvdit.irins.org/profile/441255",
    "recognition": [
      "Innovation Ambassador under the Institution's Innovation Council (Institution Innovation Council (IIC))",
      "Doctor of Philosophy (Ph.D.) Research Scholar",
      "Internship Coordinator",
      "Department Student Association coordinator ( \\u0cb8\\u0c82\\u0cb5\\u0cb9\\u0ca8) Activities"
    ]
  },
  {
    "id": "f-suraj-kadli",
    "name": "Mr. Suraj Kadli",
    "role": "Assistant Professor",
    "deptId": "ece",
    "image": "/FacultyCImages/suraj_kadli_ECE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "12 years",
    "email": "sbk@klsvdit.edu.in",
    "phone": "+91 96325 61162",
    "linkedin": "https://www.linkedin.com/in/suraj-kadli-klsvdit-haliyal",
    "areas": [
      "Signal Processing",
      "Audio Compression"
    ],
    "courses": [
      "Digital Signal Processing",
      "Control Systems",
      "Automotive Electronics",
      "Introduction To Artificial Intelligence (AI) And Applications"
    ],
    "publications": 7,
    "projects": 0,
    "bio": "Mr. Suraj Kadli is Assistant Professor in the Department of Electronics and Communication Engineering. His research focuses on Optimization of Audio Compression algorithms using Deep Learning techniques. He has guided 5 PG projects.",
    "irins": "https://klsvdit.irins.org/profile/249301",
    "recognition": [
      "information to be updated"
    ]
  },
  {
    "id": "f-a-v-kolaki",
    "name": "Mr. A V Kolaki",
    "role": "Assistant Professor",
    "deptId": "ece",
    "image": "/FacultyCImages/allamprabhu_kolaki_ECE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "26 years",
    "email": "avk@klsvdit.edu.in",
    "phone": "+91 93430 88337",
    "linkedin": "https://www.linkedin.com/in/allamprabhu-kolaki",
    "areas": [
      "Digital Communication",
      "Secured Communication"
    ],
    "courses": [
      "Digital Circuits",
      "Cryptography",
      "Fundamentals Of. Electronics",
      "Computer Netwoking"
    ],
    "publications": 15,
    "projects": 2,
    "bio": "Mr. A. V. Kolaki has been serving as an Assistant Professor in the Department of Electronics and Communication Engineering (E&CE) since 2004. With over two decades of teaching experience, he has been actively involved in imparting quality education, mentoring students, and contributing to various academic and administrative activities of the institution. He is also serving as the VDIT Examination Coordinator, responsible for the effective planning, coordination, and conduct of examination-related activities.",
    "irins": "https://klsvdit.irins.org/profile/259319#pb_information_panel",
    "recognition": [
      "Worked as Computer Center Head"
    ]
  },
  {
    "id": "f-plasin-francis-dias",
    "name": "Dr. Plasin Francis Dias",
    "role": "Assistant Professor and HOD",
    "deptId": "ece",
    "image": "/FacultyCImages/DR_plasin_dias_ECE.jpeg",
    "qualifications": "M.Tech., Ph.D.",
    "experience": "26 years",
    "email": "hodece@klsvdit.edu.in, pfd@klsvdit.edu.in",
    "phone": "+91 94484 05268",
    "linkedin": "https://linkedin.com/in/plasin-dias-966b6716b",
    "areas": [
      "Signal Processing",
      "Very Large Scale Integration (VLSI)",
      "Image Processing",
      "Communication System"
    ],
    "courses": [
      "Digital Image Processing",
      "Analog Mixed Mode Very Large Scale Integration (VLSI) Design",
      "Principles Of Communication Systems",
      "Signals And Systems"
    ],
    "publications": 18,
    "projects": 2,
    "bio": "Dr. Plasin Francis Dias is a faculty in Electronics and Communication Engineering. Her research focuses on Synthetic Aperture Radar (SAR) Polarimetry, image processing, signal processing, and VLSI-based implementations for remote sensing applications. Her interests include radar signal analysis, FPGA design, and advanced techniques for Earth observation and environmental monitoring. She has published 18 research papers in reputed journals and conferences and is actively engaged in advanced research and academic activities.",
    "irins": "https://klsvdit.irins.org/profile/249316",
    "recognition": [
      "A research article title \"Entropy Based target Identification in Synthetic Aperture Radar Polarimetry\", received Best Paper Award in \"The 2nd World Summit on Advances in Science, Engineering and Technology, Indiana Summit 2019\", Indiana University Perdue University Indianapolis, USA, International Journal of Engineering and Advanced Technology (IJEAT),",
      "A research article title \"Quantitative Approach for Snowy Feature Detection using Polarimetric Analysis\", received Best Paper Award in the Science Direct, Global Transitions Proceedings, International Conference on Intelligent Engineering Approach (ICIEA-2022)",
      "Member of Institution of Engineers India (IEI)",
      "Life member of A member of Indian Society for Technical Education (ISTE)",
      "Life Member of International Association of Engineers (IAENG)"
    ]
  },
  {
    "id": "f-vijayalaxmi-c-kalal",
    "name": "Mrs. Vijayalaxmi C. Kalal",
    "role": "Assistant Professor",
    "deptId": "ece",
    "image": "/FacultyCImages/vijayalaxmi_kalal_ECE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "9 years",
    "email": "vck@klsvdit.edu.in",
    "phone": "+91 88616 23824",
    "linkedin": "https://www.linkedin.com/in/vijaylaxmi-kalal-150a3685?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "areas": [
      "Very Large Scale Integration (VLSI)",
      "Embedded Systems",
      "Artificial Intelligence",
      "Communication System"
    ],
    "courses": [
      "Very Large Scale Integration (VLSI) Design",
      "Satellite Communication",
      "Internet Of Things",
      "Advanced Control Systems"
    ],
    "publications": 12,
    "projects": 0,
    "bio": "Mrs. Vijayalaxmi C. Kalal is a passionate academician and researcher in the field of VLSI and Embedded Systems. She earned her M.Tech in VLSI Design and Embedded Systems from VTU, Belagavi, and is currently pursuing her Ph.D. in VLSI. With 10 research publications in reputed journals and conferences, she is dedicated to advancing semiconductor technology through innovative research, inspiring teaching, and a commitment to technological excellence.",
    "irins": "https://klsvdit.irins.org/profile/378246",
    "recognition": [
      "Karnataka State Council for Science and Technology (KSCST) Student Project Programme (SPP) Coordinator of Institute",
      "Received Gold Medal in M.Tech (Master of Technology) in Very Large Scale Integration (VLSI) Design and Embedded Systems from Visvesvaraya Technological University (VTU), Belagavi for securing 1st Rank in the college"
    ]
  },
  {
    "id": "f-rohini-kallur",
    "name": "Mrs. Rohini Kallur",
    "role": "Assistant Professor",
    "deptId": "ece",
    "image": "/FacultyCImages/rohini_kallur_ECE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "18 years",
    "email": "rrk@klsvdit.edu.in",
    "phone": "+91 98865 75189",
    "linkedin": "https://www.linkedin.com/in/rohini-kallur-4a304713a?trk=contact-info",
    "areas": [
      "Communication Engineering",
      "Optical Networks",
      "Embedded Systems"
    ],
    "courses": [
      "Power Electronics",
      "Principles Of Communication Systems",
      "Artificial Intelligence And Machine Learning",
      "Digitial System Design Using Verilog"
    ],
    "publications": 20,
    "projects": 1,
    "bio": "Mrs. Rohini Kallur is an Assistant Professor with expertise in Communication Systems, Embedded Systems. She is currently purusing Ph.D in Communication domain from VTU, Belagavi. She has authored 20 research papers in reputed national and international journals and conferences. She also serves as a reviewer for reputed Scopus-indexed journals and has guided a KSCST-funded project. Passionate about teaching and research, she is dedicated to advancing knowledge and fostering innovation in the field of Electronics and Communication Engineering.",
    "irins": "https://klsvdit.irins.org/profile/249295",
    "recognition": [
      "Received Best paper award for the paper \"Optimization of Energy in Wavelength Division Multiplexing (WDM) Passive Optical Network\", in Research and Innovation in Science, Engineering and Management (RISEM)",
      "Seceratary of Kalpavruksha Kannada Sangha, Karnatak Law Society (KLS) Vishwanathrao Deshpande Institute of Technology (VDIT), Haliyal",
      "Member of Institution of Engineers India (IEI)",
      "Life Member of International Association of Engineers (IAENG)"
    ]
  },
  {
    "id": "f-mahendra-m-dixit",
    "name": "Dr. Mahendra M. Dixit",
    "role": "Professor & Dean (R&D and III)",
    "deptId": "ece",
    "image": "/FacultyCImages/DR_mahendra_dixit_ECE.jpeg",
    "qualifications": "M.Tech., Ph.D.",
    "experience": "19 years",
    "email": "deaniii@klsvdit.edu.in, mmd@klsvdit.edu.in",
    "phone": "+91 97318 69101",
    "linkedin": "",
    "areas": [
      "Very Large Scale Integration (VLSI) Design",
      "Embedded Systems",
      "Digital Image Processing",
      "Agricultural Technology"
    ],
    "courses": [
      "Digital Image Processing",
      "Embedded Systems Design",
      "Essentials Of Information Technology"
    ],
    "publications": 30,
    "projects": 5,
    "bio": "Dr. Mahendra M. Dixit is an Associate Professor in the Department of Electronics and Communication Engineering. He has been serving at SDM College of Engineering and Technology, Dharwad, since 2008. His academic and research interests include VLSI Design, Embedded Systems, and Image Processing, contributing to teaching, research, and student development.",
    "irins": "",
    "recognition": [
      "Recognized Reviewer for Springer, Elsevier Science, Taylor and Francis, Institute of Electrical and Electronics Engineers (IEEE) Transactions, Institution of Engineering and Technology (IET) (UK)",
      "Worked as Head of the Department (Electronics and Communication Engineering (E&CE)) for the period of 5+ Years at Karnatak Law Society (KLS) Vishwanathrao Deshpande Institute of Technology (VDIT) Haliyal",
      "Worked as Dean Research and Development for the period of 2 Years at Karnatak Law Society (KLS) Vishwanathrao Deshpande Institute of Technology (VDIT) Haliyal",
      "Working as President of Institution's Innovation Council (Institution Innovation Council (IIC)) since it's inception at Karnatak Law Society (KLS) Vishwanathrao Deshpande Institute of Technology (VDIT) Haliyal"
    ]
  },
  {
    "id": "f-deepak-sharma",
    "name": "Deepak Sharma",
    "role": "Assistant Professor",
    "deptId": "ece",
    "image": "/FacultyCImages/deepak_sharma_ECE.jpeg",
    "qualifications": "M.Tech.",
    "experience": "11 years",
    "email": "dss@klsvdit.edu.in",
    "phone": "+91 94818 60756",
    "linkedin": "https://www.linkedin.com/in/prof-deepak-sharma-a8362950",
    "areas": [
      "Digital Very Large Scale Integration (VLSI) Circuits"
    ],
    "courses": [
      "Analog Electronics",
      "Very Large Scale Integration (VLSI) Design And Testing",
      "Basic Electronics",
      "Automotive Electronics"
    ],
    "publications": 10,
    "projects": 0,
    "bio": "Mr. Deepak Sharma is an Assistant Professor in the Department of Electronics and Communication Engineering at KLS VDIT. He holds B.E. and M.Tech degrees from SDMCET, Dharwad. His research interests include Low-Power VLSI and Digital Circuit Design. He is currently pursuing a Ph.D. under VTU, Belagavi, at KLS VDIT.",
    "irins": "",
    "recognition": [
      "Reviewer for international journals",
      "Innovation Ambassador"
    ]
  },
  {
    "id": "f-b-b-patil",
    "name": "B B Patil",
    "role": "Assistant Professor",
    "deptId": "me",
    "image": "/FacultyCImages/basavaraj_b_patil_MECH.jpeg",
    "qualifications": "M.Tech.",
    "experience": "32 years",
    "email": "bbp@klsvdit.edu.in",
    "phone": "+91 79757 31131",
    "linkedin": "",
    "areas": [
      "Total Productive Maintenance",
      "Total Quality Management"
    ],
    "courses": [
      "Industrial Management & Entrepreneurship",
      "Theory Of Machines",
      "Non Traditional Machining",
      "Mechanical Measurements & Metrology"
    ],
    "publications": 2,
    "projects": 0,
    "bio": "Mr. B. B. Patil is an Assistant Professor in the Department of Mechanical Engineering at KLS VDIT and has been serving the institution since 2008. His areas of interest include Total Productive Maintenance and Total Quality Management. He is committed to teaching, professional development, and fostering quality practices in engineering education.",
    "irins": "",
    "recognition": [
      "A member of Institution of Engineers India (IEI) Member"
    ]
  },
  {
    "id": "f-naveen-s-hiremath",
    "name": "Naveen S Hiremath",
    "role": "Assistant Professor",
    "deptId": "me",
    "image": "/FacultyCImages/naveen_hiremath_MECH.jpeg",
    "qualifications": "M.Tech.",
    "experience": "11 years",
    "email": "nsh@klsvdit.edu.in",
    "phone": "+91 90363 95119",
    "linkedin": "https://linkedin.com/in/naveen-hiremath-70520071",
    "areas": [
      "Heat Transfer",
      "Energy Systems",
      "Machine Learning",
      "Thermodynamics"
    ],
    "courses": [
      "Thermodynamics",
      "Introduction To Python",
      "Introduction To Artificial Intelligence (AI)",
      "Fluid Mechanics"
    ],
    "publications": 3,
    "projects": 2,
    "bio": "Mr. Naveen S Hiremath serves as an Assistant Professor at KLS VDIT, Haliyal. His research interests focus on heat transfer, machine learning, and their applications in the energy domain. He is a life member of the Institution of Engineers (India) and has completed the AICTE QIP PG Certification Course in Machine Learning.",
    "irins": "https://klsvdit.irins.org/profile/249075",
    "recognition": [
      "Received Patent Grant for \"Inverse diffusion flame burner with different angled fuel jets and swirl\"",
      "Completed 6 Month All India Council for Technical Education (AICTE)-Quality Improvement Programme (QIP)-Postgraduate (PG) Certificate Programme in 'Machine Learning' from Indian Institute of Information Technology (IIIT) Raichur",
      "Completed 3 Month Course on \"Machine Learning\" Offered by Indian Institute of Technology (IIT) Dharwad",
      "2 Years of Industrial Experience in the field of Heating, Ventilation, and Air Conditioning (HVAC)"
    ]
  },
  {
    "id": "f-shankar-badiger",
    "name": "Dr. Shankar Badiger",
    "role": "Associate Professor",
    "deptId": "me",
    "image": "/FacultyCImages/DR_shankar_badiger_MECH.jpeg",
    "qualifications": "M.Tech., Ph.D.",
    "experience": "21 years",
    "email": "deanadmin@klsvdit.edu.in, snb@klsvdit.edu.in",
    "phone": "+91 98863 72913",
    "linkedin": "https://www.linkedin.com/in/shankar-badiger-61181a129?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "areas": [
      "Combustion and Heat transfer",
      "Utilisation of solar energy",
      "Air jet impingement"
    ],
    "courses": [
      "Applied Thermodynamics",
      "Turbomachines",
      "Computer Aided Engineering Drawing",
      "Introduction To Mechanical Engineering"
    ],
    "publications": 8,
    "projects": 8,
    "bio": "Dr. Shankar Badiger is an Associate Professor in Mechanical Engineering at KLS VDIT, Haliyal. He holds a Ph.D. from VTU and has over two decades of academic experience. His research spans renewable energy and sustainable engineering. He has published extensively, secured multiple patents, and guided award-winning KSCST-funded student innovation projects.",
    "irins": "https://klsvdit.irins.org/profile/248995",
    "recognition": [
      "Recognition as Research Supervisor by Visvesvaraya Technological University (VTU)",
      "Received the 'Best Project of the Year' Award from Karnataka State Council for Science and Technology (KSCST), Bengaluru, on three occasions for outstanding student innovation projects",
      "Published- 10 patents",
      "Granted - 01 patent"
    ]
  },
  {
    "id": "f-deepak-v-lokare",
    "name": "Deepak V Lokare",
    "role": "Assistant Professor",
    "deptId": "me",
    "image": "/FacultyCImages/deepak_lokare_MECH.jpeg",
    "qualifications": "M.Tech.",
    "experience": "15 years",
    "email": "dvl@klsvdit.edu.in",
    "phone": "+91 94820 24433",
    "linkedin": "https://www.linkedin.com/in/prof-deepak-lokare-41b773224",
    "areas": [
      "Analysis",
      "Design and Optimization using Taguchi technique"
    ],
    "courses": [
      "Theory Of Machines",
      "Research Methodology And Intellectual Property Rights (IPR)",
      "Management And Entrepreneurship",
      "Operation Research"
    ],
    "publications": 3,
    "projects": 3,
    "bio": "Mr. Deepak Lokare is an experienced academician serving as an Assistant Professor in the Department of Mechanical Engineering, with 15 years of teaching experience. His academic interests and expertise lie in the areas of Design Engineering and Production Engineering. Alongside his academic responsibilities, he has been serving as the Hostel In-Charge for the last four years, playing a significant role in student support and administration.",
    "irins": "https://vapt6.irins.org/profile-detail/248992",
    "recognition": [
      "Member of professional bodies including Institution of Engineers India (IEI)",
      "A member of Indian Society for Technical Education (ISTE)",
      "Received Karnataka State Council for Science and Technology (KSCST) project grants",
      "Regular Blood donor for 13 continuous years"
    ]
  },
  {
    "id": "f-gururaj-r-sattigeri",
    "name": "Gururaj R Sattigeri",
    "role": "Assistant Professor",
    "deptId": "me",
    "image": "/FacultyCImages/gururaj_sattigeri_MECH.jpeg",
    "qualifications": "M.Tech.",
    "experience": "35 years",
    "email": "grs@klsvdit.edu.in",
    "phone": "+91 94488 38507",
    "linkedin": "https://www.linkedin.com/in/gururaj-sattigeri-38442069",
    "areas": [
      "Artificial intelligence and Engineering"
    ],
    "courses": [
      "Mechanics Of Materials",
      "Computer-Aided Engineering Drawing (CAED)",
      "Finite Element Method",
      "Biology For Engineers"
    ],
    "publications": 3,
    "projects": 0,
    "bio": "Mr. Gururaj R. Sattigeri is a Senior Faculty Member in Mechanical Engineering at KLS VDIT. He holds an M.Tech. in Manufacturing Engineering from IIT Bombay (2000) and completed the AICTE-QIP PG Program in Cyber Physical Systems (2025). His interests include manufacturing, AI applications, thermal engineering, and engineering education.",
    "irins": "https://klsvdit.irins.org/248951",
    "recognition": [
      "M. Tech from Indian Institute of Technology (IIT), Bombay, All India Council for Technical Education (AICTE) Quality Improvement Programme (QIP) Postgraduate (PG) in Cyber Physical Systems from Indian Institute of Information Technology (IIIT), Dharwad",
      "All India Council for Technical Education (AICTE) Quality Improvement Programme (QIP) Postgraduate (PG) in Cyber Physical Systems from Indian Institute of Information Technology (IIIT) Dharwad in 2025"
    ]
  },
  {
    "id": "f-anant-g-joshi",
    "name": "Dr. Anant G Joshi",
    "role": "Associate Professor",
    "deptId": "me",
    "image": "/FacultyCImages/DR_anant_joshi_MECH.jpeg",
    "qualifications": "M.Tech., Ph.D.",
    "experience": "14 years",
    "email": "agj@klsvdit.edu.in",
    "phone": "+91 74110 39447",
    "linkedin": "https://www.linkedin.com/in/dr-anant-joshi-24772324a",
    "areas": [
      "Composite Materials",
      "Additive Manufacturing",
      "Product Design and Development",
      "Smart Materials"
    ],
    "courses": [
      "Design Of Machine Elements",
      "Product Design And Development",
      "Smart Materials And Systems",
      "Non Traditional Machining Processes"
    ],
    "publications": 6,
    "projects": 0,
    "bio": "Dr. Anant G. Joshi is an Associate Professor in the Department of Mechanical Engineering at KLS VDIT. He holds a Ph.D. in Composite Materials and completed his postgraduate research at the Automotive Research Association of India (ARAI), Pune. His interests include Composite Materials, Additive Manufacturing, Product Design and Development, and Smart Materials.",
    "irins": "https://klsvdit.irins.org/profile/249045",
    "recognition": [
      "Recognised as research supervisor in the Mechanical Engineering Sciences by Visvesvaraya Technological University (VTU), Belagavi",
      "Secured first place in poster presentation held at Shri Dharmasthala Manjunatheshwara (SDM) University Dharwad on the topic of sustainable composite materials",
      "Served as and recognised as volunteer of Tata ready engineer program in 2017"
    ]
  },
  {
    "id": "f-gururaj-hatti",
    "name": "Dr. Gururaj Hatti",
    "role": "Associate Professor & dean(Academics)",
    "deptId": "me",
    "image": "/FacultyCImages/DR_gururaj_hatti_MECH.jpeg",
    "qualifications": "M.Tech., Ph.D.",
    "experience": "13 years",
    "email": "deanacademics@klsvdit.edu.in, gnh@klsvdit.edu.in",
    "phone": "+91 99723 96543",
    "linkedin": "https://www.linkedin.com/in/gururaj-hatti-58b0392b/",
    "areas": [
      "Biomaterials",
      "Advanced Green Metal Matrix Composites (MMC)",
      "Additive Manufacturing"
    ],
    "courses": [
      "Operation Management",
      "Advanced Materials Technology",
      "Additive Manufacturing",
      "Project Management"
    ],
    "publications": 26,
    "projects": 1,
    "bio": "Dr. Gururaj Hatti faculty in the Department of Mechanical Engineering and Dean （Academics） at KLS VDIT. His research focuses on Biomaterials, Advanced Green MMC, Additive Manufacturing. He has supervising 3 Ph.D. scholars and is a member of ISTE,MIE,MRSI,KSTA, and more.",
    "irins": "https://klsvdit.irins.org/profile/123415",
    "recognition": [
      "Patent No. [576601] Inverse diffusion flame burner with different angled fuel jets and swirl- Granted",
      "Sanction of Student Project - 47th Series: Year 2023-2024, Project Proposal Reference No.: 47S_BE_0470, Project Proposal entitled: GREEN METAL MATRIX COMPOSITES: REPURPOSING DEBRIS FOR ENGINEERING PURPOSES, Sanctioned Amount (in Rs.): 5,500 by Karnataka State Council for Science and Technology (Karnataka State Council for Science and Technology (KSCST))",
      "Patent Published/ Granted",
      "Title of the invention: Investigation on Sliding Wear Behaviour of Zinc Alloy Reinforced with Nano B4c Composite, Application No.202341066233 A, Publication Date: 20/10/2023",
      "Title of the invention: Modified Domestic LPG Cooking Stove, Application No.202441019056 A, Publication Date: 29/03/2024",
      "Title of the invention: Inverse diffusion flame burner with different angled fuel jets and swirl, Application No.202441027549 A, Publication Date: 12/04/2024. Patent No.: 576601 - Granted",
      "Title of the invention: Portable Domestic Solar Vegetable Dryer with Swirl, Application No.202441034100 A, Publication Date: 10/05/2024",
      "Title of the invention: Teacup and Wick Type Floating Solar Still, Application No.202441055442, Publication Date: 26/07/2024",
      "Patent published on \"A floating wick type solar desalination system integrated with an artificial neural network\". 17/01/2025. No. 202541001679 A- India",
      "Patent published on \"A Jig designed for drilling on the cylindrical surface of a hub-like component\" Publication Date: 13/06/2025, Application No.202541050593",
      "Patent published on \"Solar Assisted Air Cooler with Mud Clay Pot Pieces\" Publication Date: 27/06/2025, Application No.202541058424",
      "Patent published on \" A modified inverse diffusion flame jet burner with 90 degree fuel jets\" Publication Date: 22/08/2025, Application No.202541074406",
      "Patent published on \"Solar PV-Powered Desalination System with Water-Cooled Condenser\" Publication Date: 03/10/2025, Application No.202541085873",
      "Patent published on \"AI-Powered Crop Monitoring Device in Agriculture\" Publication Date: 24/10/2025, Application No.202541083949"
    ]
  },
  {
    "id": "f-santosh-savanur",
    "name": "Santosh Savanur",
    "role": "Assistant Professor",
    "deptId": "me",
    "image": "/FacultyCImages/santosh_savanur_MECH.jpeg",
    "qualifications": "M.Tech.",
    "experience": "13 years",
    "email": "sks@klsvdit.edu.in",
    "phone": "+91 96116 81828",
    "linkedin": "https://www.linkedin.com/in/santosh-savanur-2aa6891b2",
    "areas": [
      "Vibration",
      "Condition Monitoring",
      "Composite Material"
    ],
    "courses": [
      "Engineering Drawing",
      "Python Programming",
      "Finite Element Method",
      "Innovation And Design Thinking"
    ],
    "publications": 5,
    "projects": 4,
    "bio": "Mr.Santosh Savanur working as the Assistant Professor in the Department of Mechanical Engineering since from 2013.His reserch focuses on Vibration,Condition monitoring and Composite material.He has guided 15 UG Projects.He is the member of ISTE and IEI.",
    "irins": "",
    "recognition": [
      "Co-Principal Investigator for a research project funded by Vision Group on Science and Technology (VGST) with financial support of ₹20 lakh",
      "Secured First Rank and Gold Medal in M.tech from Visvesvaraya Technological University, Belagavi",
      "Completed All India Council for Technical Education (AICTE) Quality Improvement Programme (QIP) Postgraduate (PG) Certificate Program in Cyber Security from Indian Institute of Information Technology (IIIT)-Dharwad",
      "Successfully guided 3 Karnataka State Council for Science and Technology (KSCST)-funded student projects",
      "Completed Virtual Learning Centre Initiative (VLCI)",
      "Faculty Training Program on Flow Principles and Consultancy Principles organized by Mizuho India Japan Study Centre (Ministry of International Joint Skill Centre (MIJSC)) @ Indian Institute of Management, Bangalore"
    ]
  },
  {
    "id": "f-rajat-acharya",
    "name": "Rajat Acharya",
    "role": "Assistant Professor",
    "deptId": "me",
    "image": "/FacultyCImages/rajat_acharya_MECH.jpeg",
    "qualifications": "M.Tech.",
    "experience": "13 years",
    "email": "rra@klsvdit.edu.in",
    "phone": "+91 89048 59505",
    "linkedin": "https://www.linkedin.com/in/rajat-acharya-a1837933/",
    "areas": [
      "Supply Chain Management and Operations Optimization",
      "Combustion Systems and Flame Burner Design",
      "Hydraulics and Pneumatic Systems Engineering",
      "Computational Wind Flow Analysis and Aerodynamic Studies"
    ],
    "courses": [
      "Biology For Engineers",
      "Computer Integrated Manufacturing",
      "Computer-Aided Engineering (CAE) And Machine Design",
      "Robotics And Automation"
    ],
    "publications": 1,
    "projects": 4,
    "bio": "Mr. Rajat Acharya is an academician, researcher, and training leader with over 13 years of experience in engineering education, industry collaboration, and workforce development. He specializes in curriculum design, student employability, accreditation support, research, industry partnerships, and stakeholder engagement, driving innovation, skill enhancement, and institutional excellence across academia and industry.",
    "irins": "https://klsvdit.irins.org/profile/249050",
    "recognition": [
      "Completed the All India Council for Technical Education (AICTE) Quality Improvement Programme (QIP) Postgraduate (PG) Certificate Program in Cybersecurity at Indian Institute of Information Technology (IIIT) Dharwad (2024-25).",
      " Recognized by Visvesvaraya Technological University (VTU)-Bosch Rexroth Centre of Competence, Mysuru for delivering training programs on Hydraulics and Pneumatics,",
      "Honored with the Director Excellence Award at the All India Council for Technical Education (AICTE)-EduSkills Connect for outstanding contributions to training, skill development, and industry-academia collaboration,",
      "Received the Best Paper Award at the International Conference on Sustainable Solutions in Engineering and Technology (SSET) for research contributions in agricultural innovation and sustainable engineering solutions,",
      "Active Member of the Indian Society for Technical Education (A member of Indian Society for Technical Education (ISTE))",
      "In-Charge, Royal Enfield Training Centre, Karnatak Law Society (KLS) Vishwanathrao Deshpande Institute of Technology (VDIT) (2026-Present): Leading the operations and student engagement activities of the Royal Enfield Training Centre, a state-of-the-art facility serving North Karnataka and Goa, and the only such centre established in an educational institution in Karnataka",
      "Resource Person, Visvesvaraya Technological University (VTU) Regional Centre, Mysuru (2016, 2018 &",
      "Delivered Short Term Training Programme (STTP) sessions on Hydraulics and Pneumatics",
      "Director - Training & Development, Karnatak Law Society (KLS) Vishwanathrao Deshpande Institute of Technology (VDIT) (2020-2025): Led training, placement, and industry engagement initiatives",
      "Best Paper Award (2025): Honored at the International Conference on Sustainable Solutions in Engineering and Technology (SSET) for research in agricultural innovation at Basaveshwar Engineering College (BEC) Bagalkote",
      "Successfully filed 5 patents in Innovation & Intellectual Property (2024-2025), with 1 patent already granted",
      "Trainee, Toyota Kirloskar Motors (2011-2012): Worked in supply chain, inventory management, and manufacturing operations"
    ]
  },
  {
    "id": "f-gurunath-mewundi",
    "name": "Gurunath Mewundi",
    "role": "Assistant Professor",
    "deptId": "me",
    "image": "/FacultyCImages/gurunath_mewundi_MECH.jpeg",
    "qualifications": "M.Tech.",
    "experience": "21 years",
    "email": "gmm@klsvdit.edu.in",
    "phone": "+91 81055 34380",
    "linkedin": "http://www.linkedin.com/in/gurunath-mewundi-ba0b473a2",
    "areas": [
      "Computer Numerical Control (CNC) Machining",
      "Friction Welding",
      "3D (Three-Dimensional) Printing",
      "Tooling Design"
    ],
    "courses": [
      "Machining Science And Metrology",
      "Additive Manufacturing",
      "Manufacturing Processes",
      "Material Science"
    ],
    "publications": 4,
    "projects": 3,
    "bio": "Mr. Gurunath Mewundi is an Assistant Professor in the Department of Mechanical Engineering at KLS VDIT. He has been serving the institution since 2014 and is currently pursuing a Ph.D. in Friction Welding. With 10 years of industrial experience, he has held managerial positions at WABCO-TVS India Ltd. and Automotive Axles Ltd.",
    "irins": "https://klsvdit.irins.org/profile/249061",
    "recognition": [
      "Certified Virtual Learning Centre Initiative (VLCI) course on Lean Manufacturing Practices (LMP) program - An Indian Institute of Management (IIM) Bangalore and Ministry of International Joint Skill Centre (MIJSC) Joint Venture (JV) program with highest score",
      "Completed Lean Manufacturing Practices (LMP) program - An Indian Institute of Management (IIM) Bangalore and Ministry of International Joint Skill Centre (MIJSC) Joint Venture (JV) program with highest score",
      "Member of the Institution of Engineers (MIE) membership in Institution of Engineers India (IEI)",
      "Guided students in Visvesvaraya Technological University (VTU) sanctioned projects & Industrial projects",
      "Consultancy in Computer Numerical Control (CNC) machining",
      "Mentored the students in \"The Ready Engineer\" Program, a joint initiative of Belgaum Foundry Cluster and Tata Technologies",
      "Published 3 patents"
    ]
  },
  {
    "id": "f-ranganath-n-patil",
    "name": "Ranganath N Patil",
    "role": "Associate professor",
    "deptId": "me",
    "image": "/FacultyCImages/ranganath_patil_MECH.jpeg",
    "qualifications": "M.Tech.",
    "experience": "35 years",
    "email": "rnp@klsvdit.edu.in",
    "phone": "+91 99865 97762",
    "linkedin": "https://www.linkedin.com/in/ranganath-patil-5a91a19b",
    "areas": [
      "Thermal Engineering",
      "Heat transfer",
      "Fluid dynamics"
    ],
    "courses": [
      "Basic Thermodynamics",
      "Heat Transfer",
      "Advanced Power Cycle Analysis",
      "Design Of Heat Transfer Equipments"
    ],
    "publications": 6,
    "projects": 0,
    "bio": "Mr. Ranganath N. Patil is an Associate Professor in the Department of Mechanical Engineering at KLS VDIT, Haliyal, with 35 years of teaching experience. Specializing in Thermal Engineering, he has established Thermal Engineering laboratories, published research papers in international journals and conferences, and contributed significantly through academic, administrative, and institutional development activities.",
    "irins": "https://klsvdit.irins.org/profile/248949",
    "recognition": [
      "Served as Head of Department (HOD) of Mechanical Engineering, Research Co Ordinator, Academic coordinator",
      "Completed All India Council for Technical Education (AICTE) Quality Improvement Programme (QIP) Postgraduate (PG) Certificate Program on Cyber Physical System at Indian Institute of Information Technology (IIIT), Dharwad"
    ]
  },
  {
    "id": "f-gururaj-h-joshi",
    "name": "Gururaj H Joshi",
    "role": "Assistant Professor",
    "deptId": "me",
    "image": "/FacultyCImages/gururaj_joshi_MECh.jpeg",
    "qualifications": "M.Tech.",
    "experience": "27 years",
    "email": "ghj@klsvdit.edu.in",
    "phone": "+91 94484 20102",
    "linkedin": "https://www.linkedin.com/in/prof-gururaj-joshi-2246a6266/",
    "areas": [
      "Dynamics Of Machines",
      "Vibration of Rotating Machines"
    ],
    "courses": [
      "Mechanics Of Materials",
      "Finite Element Analysis",
      "Control Systems",
      "Engineering Drawing"
    ],
    "publications": 0,
    "projects": 0,
    "bio": "Mr. Gururaj H. Joshi is an Assistant Professor in the Department of Mechanical Engineering at KLS VDIT. He holds a Bachelor's degree from Karnataka University and a Master's degree in Machine Design from Bangalore University. With four years of industrial and 25 years of teaching experience, he actively guides undergraduate and postgraduate projects.",
    "irins": "",
    
  },
  {
    "id": "f-k-s-pujari",
    "name": "Dr. K S Pujari",
    "role": "Professor & Head of Department",
    "deptId": "me",
    "image": "/FacultyCImages/DR_k_s_pujar_MECH.jpeg",
    "qualifications": "M.Tech., Ph.D.",
    "experience": "26 years",
    "email": "hodmech@klsvdit.edu.in, ksp@klsvdit.edu.in",
    "phone": "+91 94484 08457",
    "linkedin": "https://www.linkedin.com/in/dr-k-s-pujari-8a8bb28b",
    "areas": [
      "Welding of Aerospace-Grade Alloys,",
      "Additive Manufacturing,",
      "Evaluation of Welded Joints,",
      "Cyber-Physical Systems and Intelligent Welding Automation"
    ],
    "courses": [
      "Material Science",
      "Control Engineering",
      "Optimization Techniques",
      "Production And Operations Management"
    ],
    "publications": 9,
    "projects": 4,
    "bio": "Dr. K. S. Pujari (M.Tech., Ph.D.., MIE) is Professor and Head of Mechanical Engineering at KLS VDIT, Haliyal, with over 26 years of teaching and 19 years of research experience. His expertise includes welding technology, advanced manufacturing, materials characterization, and process optimization. He has secured research funding exceeding ₹60 lakh, 10 journal publications, guided Ph.D. Jury member for various Industrial awards and actively promotes industry-academia collaboration and innovation.",
    "irins": "https://klsvdit.irins.org/profile/210833",
    "recognition": [
      "Secured over ₹60 lakh Research project work as Principal Investigator (PI)/Co-Principal Investigator (PI)",
      "Member (Member of the Institution of Engineers (MIE)) of Institution of Engineers India (IEI) professional bodies",
      "Jury member for various Industrial awards",
      "Successfully Completed on May 29th 2021 an online non-credit course offered through Coursera on \"Material Processing\" authorized by Georgia Institute of Technology, North Avenue, Atlanta, GA 30332894.2000",
      "Successfully Completed on June 3rd 2021 an online non-credit course \"Deep learning Artificial Intelligence (AI)\" offered through Coursera",
      "Successfully Completed on December 2025, All India Council for Technical Education (AICTE) Quality Improvement Programme (QIP) Postgraduate (PG) Certificate Programme in Cyber Physical System"
    ]
  }
];

export const adminStaff = [
  { id: 1, name: "Shri Varaprasad Gaonkar", role: " I/c Registrar " },
  { id: 2, name: "Shri.Vadiraj B Betageri", role: " OS Admin " },
  { id: 3, name: "Shri. Vinay N. Nadgir", role: " FDA " },
  { id: 4, name: "Shri. Suraj S. Naik", role: "FDA" },
  { id: 5, name: "Mrs. Sujata Sirsat", role: "FDA" },
  { id: 6, name: "Shri. Ramesh Rajannavar", role: "FDA" },
  { id: 7, name: "Mrs. Shobha Chavan", role: " SDA " },
  { id: 8, name: "Shri. Kantu Pawar", role: " SDA " },
  { id: 9, name: "Mrs. Smita Joshi", role: " SDA " },
  { id: 10, name: "Mrs. Sita Ghotnekar", role: " SDA " },
  { id: 11, name: "Mr. Gururaj Kulkarni", role: " SDA " },
  { id: 13, name: "Ms. Chaitra Jamanis", role: " SDA " },
  { id: 12, name: "Mrs Padmavati Melinamani", role: " SDA " },
];

export const researchers = [
  { id: 1, name: "Ms. Sindhu G. Patil", role: "Research Scholar", deptId: "cse", topic: "Federated Learning for Healthcare" },
  { id: 2, name: "Mr. Rishabh K. Joshi", role: "Research Scholar", deptId: "ece", topic: "5G Beamforming Algorithms" },
  { id: 3, name: "Ms. Mihika R. Naik", role: "Research Scholar", deptId: "eee", topic: "Hybrid Solar-Wind Microgrids" },
  { id: 4, name: "Mr. Karthik S. Bhat", role: "Research Scholar", deptId: "me", topic: "Additive Manufacturing of Composites" },
  { id: 5, name: "Ms. Faiza R. Kulkarni", role: "Research Scholar", deptId: "civil", topic: "Sustainable Concrete with Industrial Byproducts" },
];

export const newsItems = [
  { id: "n1", deptId: "civil", image: "https://images.pexels.com/photos/8423416/pexels-photo-8423416.jpeg?w=1200", title: "VDIT Hosts National Conference on Sustainable Engineering", description: "The Department of Civil Engineering successfully hosted a two-day National Conference on Sustainable Engineering Practices, attended by 200+ delegates from across India.", body: "Held on April 16-17, 2026, the conference featured 24 keynote talks, 6 parallel tracks and a poster session with over 60 entries. Distinguished speakers from IIT Bombay, IISc Bengaluru and PWD Karnataka set the tone for an enriching exchange of ideas around climate-resilient infrastructure, low-carbon construction and sustainable water resources.", date: "April 18, 2026", category: "Events" },
  { id: "n2", deptId: "cse", image: "https://images.pexels.com/photos/6208728/pexels-photo-6208728.jpeg?w=1200", title: "Research Project | IoT Based Smart Agriculture", description: "Faculty members from the CSE department receive a grant from VGST Karnataka to develop low-cost IoT solutions tailored for smallholder farmers in the Uttara Kannada region.", body: "The two-year project, led by Dr. Suresh M. Patil, will design solar-powered sensor nodes for soil moisture, weather and crop-stress detection. Field deployments are planned in Haliyal, Joida and Yellapur taluks, covering 30 farms.", date: "April 10, 2026", category: "Research" },
  { id: "n3", deptId: "eee", image: "https://images.pexels.com/photos/9243572/pexels-photo-9243572.jpeg?w=1200", title: "Faculty Publication | Renewable Energy Systems", description: "VDIT EEE faculty publish a peer-reviewed article on hybrid solar-wind microgrid optimisation in the IEEE Transactions on Sustainable Energy.", body: "Dr. Ramesh B. Naik and team's article presents a model-predictive controller for hybrid microgrids that improves utilisation by 14% over baseline rule-based controllers, with field validation at the campus solar plant.", date: "March 28, 2026", category: "Research" },
  { id: "n4", deptId: "cse", image: "https://images.unsplash.com/photo-1607013407627-6ee814329547?w=1200&q=80", title: "Placement Drive 2026 | Record Offers", description: "The 2026 placement season concludes with VDIT students securing offers from leading firms including Infosys, TCS, Wipro, L&T, and several core engineering companies.", body: "85% of the eligible UG students received at least one offer; 64 students received multiple offers. The highest package this season is \u20b9 18 LPA from a Bengaluru-based product company.", date: "March 22, 2026", category: "Placement" },
  { id: "n5", deptId: "cse", image: "https://images.pexels.com/photos/3231359/pexels-photo-3231359.jpeg?w=1200", title: "NSS Activities | Village Outreach Programme", description: "VDIT NSS volunteers conduct a week-long village outreach in Haliyal Taluk, addressing digital literacy, health awareness and clean water initiatives.", body: "120 volunteers from across departments participated. The programme reached six villages with sessions on UPI safety, anti-tobacco awareness, and a free health camp organised in collaboration with the local PHC.", date: "March 14, 2026", category: "NSS" },
  { id: "n6", deptId: null, image: "https://images.unsplash.com/photo-1750379046723-5ed69ff11571?w=1200&q=80", title: "Work With Us | Faculty & Research Recruitment", description: "KLS VDIT invites applications for Assistant Professors, Lab Technicians, and Research Associates across multiple departments. Apply by May 30, 2026.", body: "Open positions span CSE, CSE (AI & ML), E&CE, EEE, Mechanical and Civil. The full notification with eligibility, qualifications and application format is available on the VDIT careers portal.", date: "March 1, 2026", category: "Recruitment" },
  { id: "n7", deptId: "eee", image: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=1200&q=80", title: "MoU Signed with Karnataka Renewable Energy Development Ltd.", description: "VDIT formalises a partnership with KREDL for joint research, internships, and energy auditing projects benefiting students of EEE and Mechanical departments.", body: "The MoU enables paid internships at KREDL field offices, joint authoring of energy audits and access to KREDL's testing infrastructure for student capstone projects.", date: "February 18, 2026", category: "Partnership" },
  { id: "n8", deptId: null, image: "https://images.pexels.com/photos/12497061/pexels-photo-12497061.jpeg?w=1200", title: "Convocation 2025 | 462 Graduates Awarded Degrees", description: "The 11th Annual Graduation Day was celebrated in the presence of Hon'ble Vice-Chancellor of VTU Belagavi as Chief Guest.", body: "12 gold medals and 8 distinction certificates were awarded across programmes. The Chief Guest delivered a stirring address calling on graduates to be sensitive to local realities even as they pursue global opportunities.", date: "December 20, 2025", category: "Events" },
  { id: "n9", deptId: "ece", image: "https://images.unsplash.com/photo-1581092335397-9583eb92d232?w=1200&q=80", title: "E&CE students publish in IEEE Sensors Journal", description: "Three undergraduate students of the E&CE department co-author a paper on low-power IoT edge nodes published in IEEE Sensors Journal.", body: "The paper is the outcome of a year-long mini-project mentored by Dr. Mahesh G. Hegde, demonstrating how disciplined undergraduate research can yield tier-1 publications.", date: "February 5, 2026", category: "Research" },
  { id: "n10", deptId: "me", image: "https://images.unsplash.com/photo-1580130544577-e22c7df3633a?w=1200&q=80", title: "SAE BAJA 2025 | VDIT Team Secures All-India Rank 38", description: "The VDIT SAE BAJA team places in the top 50 nationally, an institute best result.", body: "The team designed, built and successfully ran a single-seat off-road vehicle through the rigorous BAJA endurance event. Mentor: Prof. Kiran A. Desai." , date: "January 22, 2026", category: "Achievement" },
];

export const events = [
  { id: "e1", deptId: null, title: "Tech Symposium 'TANTRAJNANA 2026' | Annual Inter-College Fest", date: "May 8-9, 2026", time: "9:00 AM", venue: "Main Auditorium", description: "VDIT's flagship inter-college techno-cultural fest with 30+ events across coding, robotics, paper presentations, gaming and cultural categories. Open to all engineering colleges of Karnataka." },
  { id: "e2", deptId: "eee", title: "Industry Connect | Guest Lecture by Dr. Prakash Joshi on 'Future of EVs'", date: "May 14, 2026", time: "11:00 AM", venue: "EEE Seminar Hall", description: "Dr. Prakash Joshi, VP-Engineering at a leading Indian EV maker, will discuss India's electric mobility roadmap, charging infrastructure and career opportunities for fresh engineers." },
  { id: "e3", deptId: "cse-aiml", title: "Workshop on Generative AI & Prompt Engineering | Dept. of CSE (AI & ML)", date: "May 20-22, 2026", time: "10:00 AM", venue: "AI Lab, CSE Block", description: "Three-day hands-on workshop covering prompt patterns, fine-tuning open models, and building LLM-powered applications. Limited seats." },
  { id: "e4", deptId: null, title: "Faculty Development Programme | Outcome Based Education", date: "June 2-7, 2026", time: "All Day", venue: "IQAC Conference Room", description: "AICTE-sponsored FDP on OBE, attainment computation, rubric design and assessment for engineering programmes." },
  { id: "e5", deptId: null, title: "VTU Convocation 2026 | Ceremony for Graduating Batch", date: "July 12, 2026", time: "10:30 AM", venue: "VDIT Main Ground", description: "Annual graduation ceremony for the outgoing batch. Family invitations will be issued to all graduating students." },
  { id: "e6", deptId: "cse", title: "Hackathon 'CodeKshatriya' | 24-hour Coding Marathon", date: "August 5-6, 2026", time: "9:00 AM", venue: "CSE Block", description: "Annual 24-hour coding marathon. Teams of 3 build solutions for real problems shortlisted from local enterprises and NGOs." },
];

export const stats = {
  established: "2004",
  students: "1706+",
  faculty: "85+",
  alumni: "7700+",
  campus: "26 Acres",
  ugCourses: "8",
  pgCourses: "2",
  researchCentres: "7",
  //placement: "85%",
};

export const leaders = [
  { id: 1, name: "Dr. V. A. Kulkarni", role: "Principal", image: "https://images.unsplash.com/photo-1556157382-97eda2d62296?w=400&q=80", bio: "Dr. V. A. Kulkarni serves as the Principal of KLS VDIT and the Ex-Officio Member of the Local Governing Council. With decades of experience in technical education and academic leadership, he has steered the institute toward NAAC accreditation and sustained NBA tier-2 outcomes for multiple programmes." },
  { id: 2, name: "Shri. Prashant Kulkarni", role: "GC-Chairman, KLS VDIT LGC", image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&q=80", bio: "Shri. Prashant Kulkarni chairs the Local Governing Council of KLS VDIT. A long-standing member of the Karnatak Law Society, he has played a key role in shaping VDIT's strategic vision and industry-institute partnerships." },
  { id: 3, name: "Shri. V. M. Deshpande", role: "Member Secretary", image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&q=80", bio: "As Member Secretary of the LGC and Secretary of the Karnatak Law Society, Shri. V. M. Deshpande has been instrumental in establishing and nurturing VDIT since its inception in 2004." },
  { id: 4, name: "Shri. Ram Bhandare", role: "Member, LGC", image: "https://images.unsplash.com/photo-1568602471122-7832951cc4c5?w=400&q=80", bio: "Shri. Ram Bhandare serves as a member of the Local Governing Council, bringing rich experience in education administration and community service." },
  { id: 5, name: "Shri. Prakash G. Badkundri", role: "Member, LGC", image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80", bio: "A senior member of the KLS VDIT Local Governing Council, Shri. Badkundri contributes to the institute's policy framework and stakeholder engagement." },
];

export const committees = [
  { name: "Internal Quality Assurance Cell (IQAC)", chair: "Dr. V. A. Kulkarni" },
  { name: "Anti-Ragging Committee", chair: "Dr. Suresh M. Patil" },
  { name: "Internal Complaints Committee (ICC)", chair: "Dr. Suma R. Kulkarni" },
  { name: "Examination Committee", chair: "Dr. Mahesh G. Hegde" },
  { name: "Library Advisory Committee", chair: "Shri. Subhash R. Patil" },
  { name: "Discipline Committee", chair: "Dr. Vikram S. Joshi" },
  { name: "Grievance Redressal Committee", chair: "Dr. Ramesh B. Naik" },
  { name: "Research Committee", chair: "Dr. Anjali V. Kulkarni" },
  { name: "Industry Institute Interaction Cell", chair: "Prof. Anand B. Shenoy" },
  { name: "Placement Committee", chair: "Prof. Nandini D. Shet" },
];

export const placements = [
  { company: "Infosys", offers: 42, role: "Systems Engineer" },
  { company: "TCS", offers: 38, role: "Assistant Systems Engineer" },
  { company: "Wipro", offers: 28, role: "Project Engineer" },
  { company: "L&T Construction", offers: 22, role: "Graduate Engineer Trainee" },
  { company: "Cognizant", offers: 19, role: "Programmer Analyst" },
  { company: "Tech Mahindra", offers: 16, role: "Associate Software Engineer" },
  { company: "Capgemini", offers: 15, role: "Analyst" },
  { company: "Mahindra & Mahindra", offers: 9, role: "GET" },
  { company: "Bosch", offers: 8, role: "Embedded Engineer" },
  { company: "Siemens", offers: 6, role: "Engineering Trainee" },
];

export const studentClubs = [
  { id: "coding", name: "VDIT Coding Club", category: "Technical", deptId: "cse", description: "Weekly competitive-programming meets, open-source contributions and the annual CodeKshatriya hackathon.", advisor: "Mr. Rohan A. Kulkarni", image: "https://images.pexels.com/photos/6208728/pexels-photo-6208728.jpeg?w=900" },
  // { id: "ai-club", name: "AI Innovation Club", category: "Technical", deptId: "cse-aiml", description: "Reading group and weekend hack-sessions exploring the latest in machine learning and generative AI.", advisor: "Mr. Arjun B. Hegde", image: "https://images.pexels.com/photos/9243572/pexels-photo-9243572.jpeg?w=900" },
  { id: "ieee-sb", name: "IEEE Student Branch", category: "Technical", deptId: "ece", description: "Affiliated to IEEE Karnataka Section. Hosts technical workshops, competitions and IEEE student paper contests.", advisor: "Prof. Anand B. Shenoy", image: "https://images.unsplash.com/photo-1581092335397-9583eb92d232?w=900&q=80" },
  // { id: "emobility", name: "VDIT e-Mobility Club", category: "Technical", deptId: "eee", description: "Designs and races battery-electric vehicles. Active participants in EV-bike conversion projects with KREDL.", advisor: "Prof. Savita V. Patil", image: "https://images.pexels.com/photos/8423416/pexels-photo-8423416.jpeg?w=900" },
  { id: "baja", name: "SAE BAJA Team Trishul", category: "Technical", deptId: "me", description: "Designs single-seat off-road vehicles for the SAE BAJA national championship.", advisor: "Prof. Kiran A. Desai", image: "https://images.unsplash.com/photo-1580130544577-e22c7df3633a?w=900&q=80" },
  // { id: "ici", name: "ICI Students' Chapter", category: "Technical", deptId: "civil", description: "Indian Concrete Institute student chapter. Conducts site visits, workshops and the annual concrete-mix competition.", advisor: "Prof. Sandesh M. Patil", image: "https://images.pexels.com/photos/12091126/pexels-photo-12091126.jpeg?w=900" },
  { id: "nss", name: "VDIT NSS Unit", category: "Outreach", deptId: null, description: "120-strong NSS unit conducting village outreach, blood donation drives and environmental awareness.", advisor: "Faculty Co-ordinator", image: "https://images.pexels.com/photos/3231359/pexels-photo-3231359.jpeg?w=900" },
  { id: "iedc", name: "Innovation & Entrepreneurship Cell (IEDC)", category: "Innovation", deptId: null, description: "Student startup incubator with seed funding, mentorship and pitch days.", advisor: "Dr. Anjali V. Kulkarni", image: "https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=900&q=80" },
  { id: "cultural", name: "Spandana Cultural Club", category: "Cultural", deptId: null, description: "Music, dance, drama and literary club; organises the annual TANTRAJNANA cultural night.", advisor: "Cultural Coordinator", image: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=900&q=80" },
  { id: "sports", name: "VDIT Sports Club", category: "Sports", deptId: null, description: "Cricket, basketball, volleyball, athletics and indoor games. Multiple VTU-zonal medals.", advisor: "Physical Director", image: "https://images.unsplash.com/photo-1607013407627-6ee814329547?w=900&q=80" },
];

// Helpers
export const facultyByDept = (deptId) => faculty.filter((f) => f.deptId === deptId);
export const newsByDept = (deptId) => newsItems.filter((n) => n.deptId === deptId);
export const eventsByDept = (deptId) => events.filter((e) => e.deptId === deptId);
export const clubsByDept = (deptId) => studentClubs.filter((c) => c.deptId === deptId);
export const findFaculty = (id) => faculty.find((f) => f.id === id);
export const findDept = (id) => departments.find((d) => d.id === id);
export const findNews = (id) => newsItems.find((n) => n.id === id);
export const findEvent = (id) => events.find((e) => e.id === id);
export const findAnnouncement = (id) => announcements.find((a) => a.id === id);
